const it: Record<string, string> = {
  // nav
  'nav.overview': 'Panoramica',
  'nav.members': 'Membri',
  'nav.debates': 'Dibattiti',
  'nav.bills': 'Oggetti',
  'nav.votes': 'Votazioni',
  'nav.parties': 'Partiti',
  'nav.sessions': 'Sessioni',
  'nav.committees': 'Commissioni',
  'nav.chatHistory': 'Cronologia chat',
  'nav.reports': 'Rapporti',
  'nav.usage':       'Utilizzo',
  'nav.feedback':    'Feedback',
  'nav.documentation': 'Docs',
  'settings.api.title':       'Stato API',
  'settings.api.health':      'Salute del backend',
  'settings.api.desc':        'Interrogata ogni 60 secondi. Combina raggiungibilità Postgres e Meilisearch.',
  'settings.api.ok':          'Tutti i sistemi sono operativi',
  'settings.api.degraded':    'Parzialmente degradato',
  'settings.api.unreachable': 'Non raggiungibile',
  // Pagina admin di triage feedback (/feedback)
  'feedback.title':              'Triage feedback',
  'feedback.subtitle':           'Turni di chat con feedback negativo, associati alla domanda dell\'utente.',
  'feedback.window':             'Periodo',
  'feedback.errorLoad':          'Caricamento dei feedback non riuscito',
  'feedback.kpiDownvotes':       'Valutazioni negative',
  'feedback.noPrior':            'nessun dato precedente',
  'feedback.vsPrior':            'vs periodo precedente',
  'feedback.kpiRatio':           'Quota negativa',
  'feedback.rated':              'valutati',
  'feedback.kpiWithComment':     'Con commento',
  'feedback.commentSub':         'con dettaglio testuale',
  'feedback.kpiTopCategory':     'Categoria principale',
  'feedback.topCategorySub':     'problema più segnalato',
  'feedback.categoryHistogram':  'Per categoria',
  'feedback.clearCategory':      'Rimuovi filtro',
  'feedback.chartHint':          'Clicca una barra per filtrare la lista.',
  'feedback.empty':              'Nessuna valutazione negativa in questo periodo.',
  'feedback.hasComment':         'commento',
  'feedback.openConversation':   'Apri conversazione',
  'feedback.userLabel':          'Utente',
  'feedback.assistantLabel':     'Assistente',
  'feedback.noUserQuery':        '(nessuna domanda utente precedente)',
  'feedback.noAssistantText':    '(nessuna risposta testuale — solo strumento)',
  'feedback.withComment':        'Con commento',
  'feedback.filterCommentOn':    'Mostra solo elementi con commento testuale',
  'feedback.filterCommentOff':   'Filtrato per commenti — clicca per rimuovere',
  'feedback.conversation':       'Conversazione',
  'feedback.openInChatHistory':  'Apri in cronologia chat',
  'feedback.turns':              'turni D-R',
  'common.previous':             'Precedente',
  'common.next':                 'Successivo',
  'common.close':                'Chiudi',
  'nav.settings': 'Impostazioni',
  // Strumenti di feedback (👍 / 👎 / copia + modale di categorizzazione)
  'chat.feedback.helpful':            'Segna come utile',
  'chat.feedback.reportProblem':      'Segnala un problema',
  'chat.feedback.copy':               'Copia risposta',
  'chat.feedback.copied':             'Copiato',
  'chat.feedback.modal.title':        "Qual era il problema?",
  'chat.feedback.modal.hint':         "Categorizza il problema (facoltativo) e aggiungi dettagli. Entrambi sono facoltativi — anche un semplice 👎 è un segnale utile.",
  'chat.feedback.modal.category':     'Categoria',
  'chat.feedback.modal.comment':      'Commento (facoltativo)',
  'chat.feedback.modal.commentPlaceholder': 'Cosa non andava, cosa ti aspettavi?',
  'chat.feedback.modal.cancel':       'Annulla',
  'chat.feedback.modal.submit':       'Invia',
  'chat.feedback.cat.inaccurate':                 'Impreciso',
  'chat.feedback.cat.inaccurate.desc':            'Fatto errato o dato inventato',
  'chat.feedback.cat.incomplete':                 'Incompleto',
  'chat.feedback.cat.incomplete.desc':            'Ha risposto solo in parte alla domanda',
  'chat.feedback.cat.wrong_citation':             'Citazione errata',
  'chat.feedback.cat.wrong_citation.desc':        "Link alla fonte rotto o che punta all'entità sbagliata",
  'chat.feedback.cat.off_topic':                  'Fuori tema',
  'chat.feedback.cat.off_topic.desc':             'Non ha risposto alla domanda posta',
  'chat.feedback.cat.formatting':                 'Formattazione / lingua',
  'chat.feedback.cat.formatting.desc':            'Lingua sbagliata, tabella rotta, ecc.',
  'chat.feedback.cat.other':                      'Altro',
  'chat.feedback.cat.other.desc':                 'Usa il commento per spiegare',
  'chat.history.pinned':              'Fissate',
  'chat.history.today':               'Oggi',
  'chat.history.yesterday':           'Ieri',
  'chat.history.thisWeek':            'Questa settimana',
  'chat.history.older':               'Più vecchi',
  'chat.fromChat':                    'dalla chat',
  'common.search':                    'Cerca',
  'chat.history.newChat':             'Nuova chat',
  'chat.history.searchPlaceholder':   'Cerca sessioni…',
  'chat.history.empty':               'Nessuna conversazione salvata. Inizia con il widget chat.',
  'chat.history.untitled':            'Chat senza titolo',
  'chat.history.pin':                 'Fissa',
  'chat.history.unpin':               'Rimuovi',
  'chat.history.rename':              'Rinomina',
  'chat.history.archive':             'Archivia',
  'chat.history.selectHint':          'Seleziona una conversazione dalla lista per leggerla. Le nuove chat iniziano nel widget in basso a destra.',
  'chat.history.continue':            'Continua nella chat',
  'reports.listTitle':             'Rapporti',
  'reports.empty':                 'Ancora nessun rapporto. Seleziona le conversazioni nella cronologia chat e generane uno.',
  'reports.untitled':              'Rapporto senza titolo',
  'reports.selectHint':            'Seleziona un rapporto per leggerlo oppure generane uno nuovo dalle tue conversazioni nella cronologia chat.',
  'reports.generatedOn':           'Generato il',
  'reports.sourcesNote':           'Le fonti rimandano al sito ufficiale del Parlamento svizzero (parlament.ch). Generato con IA da conversazioni salvate — verifica con le fonti citate.',
  'reports.modelTip':              'Modello scelto automaticamente in base alla dimensione del rapporto',
  'reports.downloadPdf':           'PDF',
  'reports.downloadMd':            'Markdown',
  'reports.popupBlocked':          'Consenti i pop-up per questo sito per scaricare il PDF.',
  'reports.status.failed':         'non riuscito',
  'reports.confirmDelete':         'Eliminare questo rapporto? Questa azione è irreversibile.',
  'reports.generateTitle':         'Genera rapporto',
  'reports.generateHint':          'Dalla conversazione selezionata verrà redatto un rapporto di ricerca professionale, organizzato per tema. Cita solo fonti ufficiali parlament.ch.',
  'reports.turnsSelected':         'Interventi selezionati',
  'reports.conversationsSelected': 'Conversazioni selezionate',
  'reports.language':              'Lingua del rapporto',
  'reports.lang.de':               'Tedesco',
  'reports.lang.fr':               'Francese',
  'reports.lang.it':               'Italiano',
  'reports.lang.en':               'Inglese',
  'reports.generate':              'Genera rapporto',
  'reports.generating':            'Generazione…',
  'reports.generateError':         'Impossibile generare il rapporto. Riprova.',
  'reports.selectSessions':        'Seleziona per il rapporto',
  'reports.selectTurns':           'Seleziona per il rapporto',
  'reports.selectDone':            'Fine selezione',
  'reports.generateN':             'Genera rapporto ({n})',
  'reports.turnsChosen':           '{n} intervento/i selezionato/i',
  'common.cancel':                 'Annulla',
  'common.delete':                 'Elimina',
  'debates.tab.search':                 'Ricerca',
  'debates.tab.trends':                 'Tendenze',
  // Trends — compare-factions toggle
  'debates.trends.compareLabel':     '+ confronta',
  'debates.trends.exitCompare':      '× confronta',
  'debates.trends.compareTooltip':   'Confronta più gruppi affiancati',
  'common.errorLoad':                            'Caricamento fallito',
  'debates.trends.title':               'Tendenze retoriche',
  'debates.trends.subtitle':            'Variazioni annuali nel linguaggio parlamentare — sentimento, posizione, orientamento federale, intensità emotiva.',
  'debates.trends.empty':               'Nessun discorso corrisponde ai filtri attuali.',
  'debates.trends.allFactions':         'Gruppi',
  'debates.trends.allParties':          'Partiti',
  'debates.trends.allSessions':         'Sessioni',
  'debates.trends.councillorPlaceholder': 'Nome consigliere…',
  'debates.trends.chunksHint':            'Segmenti analizzati dall\'IA in questi discorsi (i discorsi lunghi sono frammentati per l\'analisi)',
  'faction.cohesion':                'Coesione',
  'faction.rebels':                  'Dissidenti',
  'faction.cohesionByYear':          'Per anno',
  'faction.cohesionByTopic':         'Per tema',
  'faction.cohesionYearSubtitle':    'Coesione percentuale per anno — quota dei voti espressi allineati con la maggioranza del gruppo.',
  'faction.cohesionTopicSubtitle':   'Coesione percentuale per area politica — i valori più bassi rivelano i temi più divisi internamente.',
  'faction.cohesionSrNote':          'I dati delle votazioni nominali del Consiglio degli Stati iniziano solo nel 2022.',
  'faction.rebelsSubtitle':          'Membri ordinati per frequenza di divergenza dalla maggioranza del gruppo (voti Sì/No). Esclusi i voti in parità; minimo 20 voti Sì/No espressi.',
  'faction.allChambers':             'Entrambi i consigli',
  'faction.rebellionRate':           'Tasso di divergenza',
  'faction.rebellionRateTip':        'Divergenze ÷ Sì/No espressi — quota dei voti Sì/No in cui il membro ha rotto la linea di gruppo.',
  'faction.rebellionDiverges':       'Divergenze',
  'faction.rebellionDivergesTip':    'Numero di voti Sì/No in cui il membro ha votato contro la maggioranza del gruppo.',
  'faction.rebellionVotes':          'Sì/No',
  'faction.rebellionVotesTip':       'Voti Sì/No personalmente espressi dal membro e considerati in questa classifica. Astensioni e voti con gruppo in parità sono esclusi — da qui la differenza con il totale "A registro" della scheda del membro.',
  'faction.votes':                   'voti',
  'parties.unityRanking':            'Classifica unità gruppi',
  'parties.unityRankingTip':         'Unità di voto di ciascun gruppo per camera (Consiglio nazionale e Consiglio degli Stati). Dati del Consiglio degli Stati dal 2022. Clicca una barra per aprire il gruppo.',
  'votes.demographics.title':        'Statistiche',
  'votes.demographics.subtitle':     'come si è ripartito il voto nel consiglio',
  'votes.demographics.notParticipating': 'Non partecipante',
  'votes.demographics.total':        'Totale',
  'votes.demographics.tenure':       'Anzianità',
  'tenure.bucket.veteran':           'Uscenti',
  'tenure.bucket.newcomer':          'Nuovi eletti',
  'member.member':                   'Membro',
  'bills.tab.search':                'Ricerca',
  'bills.tab.analytics':             'Analisi',
  'bills.analytics.title':           'Analisi degli oggetti',
  'bills.analytics.subtitle':        'Come si distribuiscono le presentazioni per tema, anno, tipo, dipartimento o intenzione.',
  'bills.analytics.clickToFilter':   'Clicca per filtrare',
  'bills.analytics.yearRange':       'Anni',
  'bills.analytics.yearFrom':        'Anno iniziale',
  'bills.analytics.yearTo':          'Anno finale',
  'bills.analytics.allYears':        'Tutti',
  'common.clear':                    'Azzera',
  'bills.analytics.submissions':     'Presentazioni',
  'bills.analytics.concluded':       'Concluso',
  'bills.analytics.metricsTooltip':  'Presentazioni conta gli affari depositati per gruppo nel periodo selezionato. Concluso indica quanti di essi sono stati nel frattempo evasi (stato «Erledigt»), con la relativa quota tra parentesi.',
  'bills.analytics.topic':           'Tema',
  'bills.analytics.year':            'Anno',
  'bills.analytics.affairType':      'Tipo',
  'bills.analytics.department':      'Dipartimento',
  'bills.analytics.intent':          'Intenzione',
  'bills.analytics.faction':         'Gruppo',
  'bills.analytics.party':           'Partito',
  'bills.analytics.canton':          'Cantone',
  'bills.analytics.council':         'Consiglio',
  'bills.analytics.councillor':      'Consigliere',
  'bills.analytics.committee':       'Commissione',
  'bills.analytics.hiddenDimTip':    'Applicato dal chatbot. Passa a una dimensione visibile per uscire.',
  'bills.legislativePeriod':         'Legislatura',
  'bills.allLegPeriods':             'Legislature',
  'bills.dateRange':                 'Data',
  'bills.fcRecommendation':          'Raccomandazione CF',
  'bills.committeeRecommendation':   'Raccomandazione Commissione',
  'filter.tooltip.legislativePeriod': 'Filtra per legislatura (52=2023→, 51=2019–23, 50=2015–19)',
  'parties.composition.title':       'Composizione del consiglio',
  'debates.trends.scoreAxis':           'Punteggio',
  'debates.trends.emotionalityAvg':     'Emot. media',
  'debates.trends.metric.sentiment':    'Sentimento',
  'debates.trends.metric.alignment':    'Posizione',
  'debates.trends.metric.federalism':   'Federalismo',
  'debates.trends.metric.emotionality': 'Emotività',
  // anchor
  'anchor.researching': 'Ricerca:',
  'anchor.clear': 'Cancella',
  // common
  'common.all': 'Tutti',
  'common.impact': 'Impatto',
  'common.sensitivity': 'Polarizzazione',
  'common.centralization': 'Federalismo',
  'common.centralizShort': 'Federalismo',
  'common.impact.tooltip': 'Quanto questo disegno di legge incide sulla società, sull\'economia o sulla legislazione svizzera. 1 = limitato/minore, 10 = ampio/significativo.',
  'common.sensitivity.tooltip': 'Quanto questo tema è politicamente controverso o divisivo. 1 = non controverso, 10 = altamente polarizzante.',
  'common.centralization.tooltip': 'Direzione dello spostamento di potere. 1 = fortemente cantonale/locale, 10 = fortemente federale/centralizzato.',

  // Phase 4.5 — Badge di anomalie classificate dall'IA
  'anomaly.controversial':            'Controverso',
  'anomaly.controversial.tooltip':    "Valuta la tendenza polarizzante dell'oggetto per la società svizzera (economia, politica, diritto e cultura). 1 = bassa polarizzazione / 10 = forte polarizzazione",
  'anomaly.polarizing':               'Polarizzante',
  'anomaly.polarizing.tooltip':       "Valuta la tendenza polarizzante dell'oggetto per la società svizzera (economia, politica, diritto e cultura). 1 = bassa polarizzazione / 10 = forte polarizzazione",
  'anomaly.highImpact':               'Impatto',
  'anomaly.highImpact.tooltip':       "Valuta l'incidenza dell'oggetto sulla società svizzera (economia, politica, diritto e cultura). 1 = incidenza limitata / 10 = incidenza estesa",
  'anomaly.centralizing':             'Centralizzante',
  'anomaly.centralizing.tooltip':     "Valuta se l'oggetto uniforma e centralizza la società svizzera (economia, politica, diritto e cultura). 1 = rafforzamento del federalismo / 10 = espansione del centralismo",
  'anomaly.decentralizing':           'Federalista',
  'anomaly.decentralizing.tooltip':   "Valuta se l'oggetto uniforma e centralizza la società svizzera (economia, politica, diritto e cultura). 1 = rafforzamento del federalismo / 10 = espansione del centralismo",
  'anomaly.minorityReport':           'Rapporto di minoranza',
  'anomaly.minorityReport.tooltip':   "Una minoranza della commissione ha depositato un'opposizione scritta («bekämpft») — l'oggetto reca una controproposta oltre la posizione di maggioranza.",
  'anomaly.fastTracked':              'Procedura accelerata',
  'anomaly.fastTracked.tooltip':      'Risolto eccezionalmente in fretta — meno di 90 giorni dal deposito alla votazione finale. Spesso indica una procedura d\'urgenza.',
  'anomaly.heated':                   'Acceso',
  'anomaly.heated.tooltip':           'Discorso emotivamente carico — emotività 7–8 su 10.',
  'anomaly.confrontational':          'Conflittuale',
  'anomaly.confrontational.tooltip':  'Tono fortemente conflittuale — emotività 9 o 10 su 10.',
  'anomaly.closeVote':                'Voto in bilico',
  'anomaly.closeVote.tooltip':        'Deciso con meno del 5% di scarto tra Sì e No — pochi voti avrebbero ribaltato il risultato.',
  'anomaly.rapporteur':               'Relatore',
  'anomaly.rapporteur.tooltip':       'Portavoce ufficiale della commissione che presenta l\'oggetto in plenaria — il discorso veicola la posizione formale della commissione.',
  'common.submittedBy': 'Presentato da',
  'common.department': 'Dipartimento',
  'common.status': 'Stato',
  'common.trigger': 'Fattore scatenante',
  'common.words': 'parole',
  'common.back': 'Indietro',
  'common.active': 'Attivo',
  'common.loading': 'Caricamento…',
  'common.loadMore': 'Carica altri',
  'common.clearAll': 'Cancella tutto',
  'common.retry': 'Riprova',
  'common.error.title': 'Si è verificato un errore',
  'common.error.body': 'Impossibile caricare questo contenuto. Riprova.',
  'council.NR': 'Consiglio nazionale',
  'council.SR': 'Consiglio degli Stati',
  'council.V': 'Assemblea federale (Camere riunite)',
  'council.BR': 'Consiglio federale',
  'filter.tooltip.party':     'Filtra per appartenenza politica. Selezionabili più partiti contemporaneamente.',
  'filter.tooltip.faction':   'Filtra per gruppo parlamentare (V·UDC, S·PS, RL·PLR, M-E·Centro, G·Verdi, GL·VL).',
  'filter.tooltip.canton':    'Filtra per cantone di rappresentanza. Più cantoni per confronti incrociati.',
  'filter.tooltip.council':   'Consiglio nazionale vs Consiglio degli Stati. Entrambi per tutti i parlamentari.',
  'filter.tooltip.gender':    'Filtra i membri per genere.',
  'filter.tooltip.committee': 'Filtra per appartenenza attuale alle commissioni. Più per intersezioni.',
  'filter.year':              'Anno',
  'filter.session':           'Sessione',
  'filter.tooltip.year':      'Anno di presentazione del disegno — quando è stato introdotto per la prima volta. Non l\'anno dell\'ultima trattazione o votazione.',
  'filter.tooltip.session':   'Tipo di sessione nell\'anno (primavera, estate, autunno, inverno).',
  'filter.tooltip.status':    'Attivi = membri in carica. Ex = solo membri passati.',
  // Bills page (4.8 + IWP Bundle 1)
  'filter.tooltip.billType':            'Tipo di strumento parlamentare: Mozione, Postulato, Interpellanza, Iniziativa parlamentare, ecc. Più tipi combinabili.',
  'filter.tooltip.billStatus':          'Stato procedurale attuale del disegno (presentato, in corso, accettato, respinto, ritirato).',
  'filter.tooltip.department':          'Dipartimento o ufficio federale competente.',
  'filter.tooltip.number':              'Filtra per numero di oggetto esatto, es. 24.3145. I caratteri jolly non sono supportati.',
  'filter.tooltip.submittedBy':         'Filtra per autore — consigliere, gruppo o istituzione come il Consiglio federale o una commissione parlamentare.',
  'filter.tooltip.aiTopic':             'Area politica classificata dall\'IA (es. Salute, Energia, Migrazione). Un tema dominante per disegno.',
  'filter.tooltip.aiIntent':            'Intento del disegno classificato dall\'IA (proporre nuova legge, richiedere un rapporto, porre una domanda).',
  'filter.tooltip.aiAudience':          'Pubblico destinatario classificato dall\'IA (cittadini, imprese, cantoni, ecc.).',
  'filter.tooltip.aiTrigger':           'Trigger esterno classificato dall\'IA (sentenza, direttiva UE, evento pubblico, ecc.).',
  'filter.tooltip.aiMinImpact':         'Punteggio minimo di impatto (1–10). Quanto il disegno modifica il diritto svizzero o la politica pubblica. Valutato dall\'IA.',
  'filter.tooltip.aiMinSensitivity':    'Punteggio minimo di sensibilità politica (1–10). Grado di controversia politica o tensione tra partiti. Valutato dall\'IA.',
  'filter.tooltip.aiMinCentralization': 'Punteggio minimo di centralizzazione (1–10). Quanto il disegno sposta le competenze verso il livello federale.',
  // Votes page (4.8 + IWP Bundle 1)
  'filter.tooltip.voteYear':            'Anno della votazione (data della votazione), indipendente dall\'anno di presentazione del disegno sottostante.',
  'filter.tooltip.voteStatus':          'Esito della votazione: accettato, respinto, parità o in sospeso.',
  'filter.tooltip.voteKeyword':         'Ricerca a testo intero nei titoli delle votazioni e dei disegni sottostanti.',
  'filter.tooltip.closeOnly':           'Mostra solo votazioni contestate — scarto di 10 voti o meno tra Sì e No.',
  'filter.tooltip.splitOnly':           'Mostra solo votazioni in cui almeno un gruppo era diviso internamente per più del 20%.',
  // Debates page (4.8 + IWP Bundle 1)
  'filter.tooltip.debateYear':          'Anno in cui si è svolto il dibattito.',
  'filter.tooltip.language':            'Lingua del discorso (DE, FR, IT).',
  'filter.tooltip.speaker':             'Filtro a testo intero sul nome dell\'oratore (il cognome basta).',
  'filter.tooltip.role':                'Ruolo dell\'oratore nel dibattito: relatore, consigliere federale, membro ordinario, ecc.',
  'filter.tooltip.sentiment':           'Tono generale del discorso classificato dall\'IA: positivo, neutro o negativo.',
  'filter.tooltip.position':            'Posizione rispetto al disegno dibattuto: A favore, Sostegno condizionato, Neutrale o Contrario.',
  'filter.tooltip.federalism':          'Orientamento federalista del discorso: filo-federale (centralizzazione) o filo-cantonale (decentralizzazione).',
  'filter.tooltip.amendment':           'Mostra solo i discorsi in cui è stato proposto esplicitamente un emendamento.',
  'filter.tooltip.businessFilter':      'Filtra i discorsi per numero di oggetto sottostante (es. 24.3145).',
  // Sessions page (4.8 + IWP Bundle 1)
  'filter.tooltip.sessionYear':         'Anno in cui si è svolta la sessione.',
  'filter.tooltip.season':              'Tipo di sessione: sessione ordinaria primavera/estate/autunno/inverno o sessione speciale.',
  // Committees page (4.8 + IWP Bundle 1)
  'filter.tooltip.committeeType':       'Tipo di commissione: commissione permanente, commissione di vigilanza o altri organi speciali.',
  'filter.tooltip.committeeActive':     'Filtra in base al fatto che la commissione sia attualmente attiva o sia stata sciolta/sostituita.',
  'filter.tooltip.commission':          'Filtra per commissione permanente principale (es. CPE) e tutti i suoi organi — entrambe le camere, sottocommissioni e gruppi di lavoro.',
  // Generic
  'filter.tooltip.search':              'Ricerca a testo intero sui campi nome. Cognome e corrispondenze parziali funzionano entrambi.',
  // SessionPicker (IWP Bundle 2)
  'filter.allSessions':                 'Sessioni',
  'filter.tooltip.sessionPicker':       'Filtra su una sessione specifica. Scegli l\'anno, poi espandi per vedere le sessioni di primavera, estate o straordinarie.',
  // SessionDetail — highly-relevant bills card (IWP Bundle 2)
  'session.highlights.title':           'Affari più importanti di questa sessione',
  'session.highlights.subtitle':        'Affari all\'ordine del giorno di questa sessione, classificati dall\'IA in base alla portata (impatto) e alla polarizzazione politica.',
  'session.highlights.empty':           'Nessun disegno con elevato impatto o polarizzazione all\'ordine del giorno di questa sessione.',
  'empty.noResultsTitle': 'Nessun risultato per questi filtri',
  'empty.noResultsHint':  'Prova a rimuovere uno o più filtri per ampliare la ricerca.',
  'empty.removeFilter':   'Rimuovi questo filtro',
  'presets.save':              'Salva filtro',
  'presets.saveTooltip':       'Salva i filtri attuali come preimpostazione',
  'presets.dropdown':          'Preimpostazioni',
  'presets.applyHeading':      'Applica preimpostazione',
  'presets.manageHint':        'Gestisci in Impostazioni → Gestione preimpostazioni',
  'presets.modal.title':       'Salva filtro',
  'presets.modal.nameLabel':   'Nome',
  'presets.modal.namePlaceholder': 'es. Mozioni UDC migrazione T1 2025',
  'presets.modal.hint':        'Salvare con un nome esistente sovrascrive la preimpostazione.',
  'presets.modal.cancel':      'Annulla',
  'presets.modal.save':        'Salva',
  'presets.modal.saving':      'Salvataggio…',
  'common.results': 'risultati',
  'common.filteredBy': 'Filtrato per',

  // ── Notifiche / lista di osservazione ─────────────────────────────────
  'notif.bell.aria':                 'Notifiche',
  'notif.bell.unread':               'non lette',
  'notif.dropdown.title':            'Notifiche',
  'notif.dropdown.markAllRead':      'Segna tutte come lette',
  'notif.dropdown.empty':            'Nessuna attività recente.',
  'notif.dropdown.viewAll':          'Vedi tutte le notifiche',
  'notif.row.voteResult':            'Votazione finale su {affair} — {title}',
  'notif.row.billStatus':            '{affair} — {title}: stato cambiato in {status}',
  'notif.row.sessionReminder':       'Sessione in arrivo: {name}',
  'notif.row.memberVote':            '{member} ha votato {decision} su {affair} — {title}',
  'notif.row.memberSpeech':          '{member} è intervenuto su {affair} — {title}',
  'notif.row.generic':               'Nuovo evento su un elemento osservato',
  'notif.detail.voteTallies':        'Sì {yes} · No {no} · Astensione {abs}',
  'notif.detail.statusChange':       'Da "{from}" a "{to}"',
  'notif.page.title':                'Notifiche',
  'notif.page.subtitle':             'Eventi sugli oggetti, votazioni e membri che osservi.',
  'notif.page.onlyUnread':           'Solo non lette',
  'notif.page.markAllRead':          'Segna tutte come lette',
  'notif.page.empty':                'Nessuna notifica al momento.',
  'notif.page.emptyUnread':          'Nessuna notifica non letta.',
  'notif.page.emptyHint':            "Clicca il segnalibro su un oggetto per iniziare a seguirlo.",
  'watch.watch':                     'Osserva',
  'watch.watching':                  'In osservazione',
  'watch.full':                      'Lista piena (max 100)',
  'watch.error':                     'Aggiornamento fallito — riprova',
  // Modale di gestione della lista di osservazione (apri da Impostazioni → Gestisci)
  'watchlist.modal.title.bills':     'Oggetti osservati',
  'watchlist.modal.title.members':   'Membri osservati',
  'watchlist.modal.title.votes':     'Voti osservati',
  'watchlist.modal.empty.bills':     'Non stai ancora osservando nessun oggetto.',
  'watchlist.modal.empty.members':   'Non stai ancora osservando nessun membro.',
  'watchlist.modal.empty.votes':     'Non stai ancora osservando nessun voto.',
  'watchlist.modal.emptyHint':       'Clicca il segnalibro su una pagina di dettaglio per iniziare a osservare.',
  'watchlist.modal.unavailable':     'Non disponibile',
  'watchlist.modal.open':            'Apri',
  'watchlist.modal.remove':          'Rimuovi',
  'watchlist.modal.close':           'Chiudi',
  'watchlist.modal.done':            'Fatto',
  'watchlist.modal.filterBy':        'Filtro',
  'watchlist.modal.clearFilter':     'Azzera filtro',
  'watchlistTagFilter.label':        'Tag',
  'watchlistTagFilter.activeLabel':  '{n} tag',
  'watchlistTagFilter.dropdownTitle':'I tuoi tag di osservazione',
  'watchlistTagFilter.clear':        'Azzera',
  'watchlistTagFilter.andHint':      'Gli elementi devono avere tutti i tag selezionati.',
  'watchlistTagFilter.banner':       'Lista di osservazione · {n} {kind}',
  'watchlistTagFilter.taggedLabel':  'taggati',
  'watchlistTagFilter.emptyMatch':   'Nessun elemento osservato corrisponde a questi tag.',
  'watchlistTagFilter.emptyMatchHint':"Rimuovi un tag dal filtro o aggiungi altri elementi tramite la modale della lista di osservazione.",
  'tags.selector.title':             'Tag',
  'tags.selector.noneYet':           'Nessun tag — creane uno in Impostazioni → Notifiche → Tag.',
  'tags.selector.createNew':         'Crea nuovo tag',
  'tags.selector.namePlaceholder':   'Nome del tag',
  'tags.selector.create':            'Crea',
  'tags.selector.cancel':            'Annulla',
  'tags.atCap':                      'max 10',
  'tags.full':                       'Limite raggiunto (max 10 tag per elemento)',
  'tags.duplicate':                  'Esiste già un tag con questo nome',
  'tags.error':                      'Aggiornamento fallito — riprova',
  'tagsManager.header':              'I tuoi tag',
  'tagsManager.empty':               'Nessun tag al momento. Clicca "Crea tag" sopra per organizzare i tuoi oggetti e membri osservati.',
  'tagsManager.hint':                'Eliminare un tag lo rimuove anche da tutti gli elementi a cui era associato.',
  'tagsManager.confirmDelete':       'Eliminare il tag "{name}"? Verrà rimosso da tutti gli elementi a cui era associato.',
  'tagsManager.edit':                'Rinomina / ricolora',
  'tagsManager.delete':              'Elimina tag',
  'tagsManager.save':                'Salva',
  'tagsManager.cancel':              'Annulla',
  'tagsManager.create':              'Crea tag',
  'tagsManager.namePlaceholder':     'Nome del tag',
  'tagsManager.color':               'Colore',
  'tagsManager.userCapReached':      'Limite raggiunto (max 30 tag per utente)',
  // Etichette dei chip filtro — vedi nota in en.ts: prima i chip mostravano
  // il testo grezzo della chiave perché useT() restituisce la chiave stessa
  // quando manca, non il suffisso `|| 'Fallback'` al sito di chiamata.
  'bills.affairNumber':       'N° oggetto',
  'bills.type':               'Tipo oggetto',
  'bills.status':              'Stato',
  'bills.department':         'Dipartimento',
  'filter.language':          'Lingua',
  'filter.status':            'Stato',
  'debates.role':             'Ruolo',
  'chat.provenanceTooltip':   'Filtri applicati da un suggerimento del chatbot',
  'common.noResults': 'Nessun risultato trovato.',
  'common.clearFilters': 'Cancella filtri',
  'common.current': 'Attuale',
  'common.past': 'Passato',
  'common.present': 'Oggi',
  'common.exportCSV': 'Esporta come CSV',
  'csv.filtersApplied': 'Filtri applicati',
  'csv.noFilters': 'Nessuno (tutti i risultati)',
  'csv.legislature': 'Legislatura',
  'csv.vote': 'Votazione',
  'csv.outcome': 'Esito',
  // filters
  'filter.allParties': 'Partiti',
  'filter.allCantons': 'Cantoni',
  'debates.partyTooltip':  'Filtra gli interventi per partito dell\'oratore. Si applica alla vista tendenze; la lista raggruppa per gruppo parlamentare.',
  'debates.cantonTooltip': 'Filtra gli interventi per cantone dell\'oratore.',
  'filter.allFactions': 'Gruppi',
  'filter.allCouncils': 'Consigli',
  'filter.allGenders': 'Generi',
  'filter.allYears': 'Anni',
  'filter.allMembers': 'Membri',
  'filter.allCommittees': 'Commissioni',
  'filter.committee': 'Commissione',
  'filter.activeOnly': 'Attivo',
  'filter.formerOnly': 'Ex membri',
  'sort.by': 'Ordina per',
  'sort.name': 'Nome',
  'sort.joined': 'Anno di ingresso',
  'sort.cohesion': 'Coesione',
  'sort.dob':'Data di nascita',
  'sort.ascending': 'Crescente',
  'sort.descending': 'Decrescente',
  'sort.submissionDate': 'Data di presentazione',
  'filter.canton': 'Cantone (es. ZH)',
  'filter.searchName': 'Cerca per nome…',
  // omni search
  'omni.placeholder':  'Cerca membri, oggetti, votazioni, discorsi…',
  'omni.scopeLabel':   'Cerca in',
  'omni.hint.members': 'Nomi, partiti, cantoni',
  'omni.hint.bills':   'Oggetti per parola chiave',
  'omni.hint.votes':   'Titoli di votazione',
  'omni.hint.debates': 'Discorsi parlamentari',
  'omni.searching':    'Ricerca in corso…',
  'omni.noResults':    'Nessun risultato per',
  'omni.viewAll':      'Vedi tutti in',
  'omni.kbdNav':       'navigare',
  'omni.kbdOpen':      'aprire',
  'omni.kbdClose':     'chiudere',
  'filter.party': 'Partito',
  'filter.faction': 'Gruppo',
  'filter.canton.label': 'Cantone',
  'filter.gender':  'Genere',
  'filter.council': 'Consiglio',
  'filter.commission': 'Commissione',
  'filter.allCommissions': 'Commissioni',
  'filter.tooltip.commissionAffair': 'Filtra per la commissione parlamentare competente.',
  // councils
  'council.nr': 'Consiglio nazionale',
  'council.sr': 'Consiglio degli Stati',
  'council.bundesrat': 'Consiglio federale',
  // gender
  'gender.male': 'Maschile',
  'gender.female': 'Femminile',
  // members
  'members.title': 'Membri / Consiglieri',
  'members.legislativePeriod': 'Legislatura',
  'members.interest':          'Interesse',
  'members.interestMinCount':  'Interessi',
  'members.occupation':        'Professione',
  'members.employer':          'Datore di lavoro',
  'members.nativeLanguage':    'Lingua madre',
  'members.subtitle': 'Sfoglia i membri attivi del parlamento.',
  // member detail tabs
  'tab.profile': 'Profilo',
  'tab.activity': 'Attività',
  'tab.partyHistory': 'Storia del partito',
  'tab.history': 'Cronologia',
  'history.dim.party': 'Partito',
  'history.dim.council': 'Consiglio',
  'history.dim.legislation': 'Legislatura',
  'history.dim.commission': 'Commissione',
  'history.legislature': 'Legislatura',
  'member.noHistory': 'Nessuna cronologia per questo filtro.',
  'tab.votingRecord': 'Registro delle votazioni',
  'tab.speeches': 'Discorsi',
  'tab.bills': 'Oggetti depositati',
  // member detail sections
  'member.occupations': 'Professioni',
  'member.interests': 'Interessi dichiarati',
  'member.noOccupations': 'Nessun dato professionale disponibile.',
  'member.born': 'Nato/a',
  'member.gender': 'Genere',
  'member.citizenship': 'Cittadinanza',
  'member.nativeLang': 'Lingua madre',
  'member.marital': 'Stato civile',
  'member.children': 'Figli',
  'member.military': 'Militare',
  'member.elected': 'Eletto/a',
  'member.oath': 'Giuramento',
  'member.joined': 'Entrata',
  'member.left': 'Uscita',
  'member.allMembers': 'Membri',
  'member.totalVotes': 'A registro',
  'member.totalVotesTip': 'Tutti i voti registrati a nome di questo membro, comprese assenze e voti scusati. Il tasso di presenza indica la quota di questi voti a cui il membro ha effettivamente partecipato.',
  'member.cast': 'Espressi',
  'member.castTip': 'Decisioni Sì, No e Astensione combinate — i voti effettivamente espressi dal membro.',
  'member.yesRate': 'Tasso sì',
  'member.yesRateTip': 'Quota dei voti a registro in cui il membro ha votato Sì. Le assenze fanno parte del denominatore.',
  'member.noRate': 'Tasso no',
  'member.noRateTip': 'Quota dei voti a registro in cui il membro ha votato No. Le assenze fanno parte del denominatore.',
  'member.abstainTip': 'Quota dei voti a registro in cui il membro si è astenuto. Le assenze fanno parte del denominatore.',
  'member.attendance': 'Presenza',
  'member.attendanceTip': 'Quota dei voti a cui il membro ha partecipato (Sì, No o Astensione) sul totale dei voti possibili durante il mandato.',
  'member.distribution': 'Distribuzione voti',
  'member.paid': 'Retribuito',
  'member.cohesion': 'Coesione',
  'member.cohesionTip': 'Con quale frequenza questo membro vota con la maggioranza del suo gruppo nelle decisioni Sì/No.',
  'member.withFaction': 'Con il gruppo',
  'member.withFactionTip': 'Voti Sì/No in cui questo membro ha votato CON la maggioranza del suo gruppo (numero e quota = coesione).',
  'member.againstFaction': 'Contro il gruppo',
  'member.againstFactionTip': 'Voti Sì/No in cui questo membro ha votato CONTRO la maggioranza del suo gruppo (numero e quota).',
  'member.withMajority': 'Con la maggioranza',
  'member.withMajorityTip': 'Voti Sì/No in cui il membro era dalla parte vincente (maggioranza del consiglio), indipendentemente dal gruppo.',
  'member.withMinority': 'Con la minoranza',
  'member.withMinorityTip': 'Voti Sì/No in cui il membro era dalla parte perdente (minoranza del consiglio).',
  'member.votesLoadError': 'Impossibile caricare i voti.',
  'member.cohesionOverTime': 'Fedeltà al gruppo nel tempo',
  'member.cohesionChart.aligned': '{aligned} su {base} voti del gruppo',
  'member.cohesionChart.dissent': '{n} contro il gruppo',
  'member.dissentOnly': 'Solo divergenze',
  'member.dissentBadge': 'Divergenza',
  'member.compare': 'Confronta',
  'member.compareBar': 'Confronta {n} membri',
  'member.compareHint': 'Seleziona fino a 3 membri per confrontarli',
  'member.clearSelection': 'Cancella selezione',
  'member.contact': 'Contatto & Link',
  'member.topTopics': 'Argomenti principali',
  'member.noPartyHistory': 'Nessuna storia del partito disponibile.',
  // debates
  'debates.title': 'Dibattiti & Discorsi',
  'debates.subtitle': 'Cerca discorsi parlamentari con ricerca semantica AI.',
  'debates.searchPlaceholder': 'Cerca discorsi semanticamente o per numero dell\'oggetto (es. \'politica climatica\', 25.041)',
  'debates.speakerPlaceholder': 'Nome dell\'oratore',
  'debates.businessNumberPlaceholder': 'Numero dell\'oggetto (es. 25.218)',
  'debates.emptyTitle': 'Cerca discorsi parlamentari',
  'debates.emptySubtitle': 'Usa la barra di ricerca per trovare discorsi per argomento, o filtra per oratore, anno o consiglio.',
  'debates.noResults': 'Nessun discorso trovato per questa ricerca.',
  'debates.semanticMode': 'Ricerca semantica',
  'debates.allLangs': 'Lingue',
  'debates.recentSpeeches': 'Discorsi recenti',
  'debates.debateSessions': 'Sessioni di dibattito',
  'debates.sessionUnknown': 'Sessione',
  'debates.loadingChronology': 'Caricamento della cronologia completa dei dibattiti…',
  'debates.loadingMoreDebates': 'Caricamento di altri dibattiti…',
  'debates.backToDebates': 'Torna ai dibattiti',
  'debates.fullSpeech': 'Discorso completo',
  'debates.topSpeakers': 'Oratori principali',
  'debates.topSpeakersOnTopic': 'Oratori principali su questo argomento',
  'debates.factionActivity': 'Attività per gruppo',
  'debates.contributionToTopic': 'Contributo al tema',
  'debates.contributionOfTotal': '{count} interventi su {total} sul tema',
  'debates.contributionRank': 'Posizione {rank} su {total} oratori su questo tema',
  'debates.speeches': 'discorsi',
  'debates.speakersCount': 'oratori',
  'debates.newestFirst': 'Più recenti prima',
  'debates.oldestFirst': 'Più vecchi prima',
  'debates.debateThread': 'Filo del dibattito',
  'debates.speechesInDebate': 'discorsi in questo dibattito',
  'debates.singleStatement': 'Intervento singolo',
  'debates.singleStatementTip': 'Un solo intervento (di solito del presidente o del relatore) — nessun dibattito.',
  'debates.viewSpeech': 'Vedi discorso completo',
  'debates.match': 'corrispondenza',
  'debates.date': 'Data',
  'debates.council': 'Camera',
  'debates.affair': 'Oggetto',
  'debates.current': 'corrente',
  'debates.unknownSpeaker': 'Oratore sconosciuto',
  'debates.noTranscript': 'Nessun testo disponibile per questo intervento.',
  'debates.noTranscriptShort': 'Nessun testo disponibile.',
  'debates.viewOnParlament': 'Vedi su parlament.ch',
  'debates.parlamentCh': 'parlament.ch',
  'debates.searchCap': 'limite indice di ricerca',
  'debates.searchCapTip': 'La ricerca testuale restituisce al massimo 1.000 risultati. Usa i filtri per anno, consiglio o gruppo per affinare.',
  'debates.speechesPerMember': 'per membro',
  'debates.factionActivityNote': 'Larghezza normalizzata per dimensione del gruppo',
  'debates.shareOfResults': 'Quota dei risultati',
  'debates.activeMembers': 'Membri attivi',
  'debates.filterByYear': 'Filtra per anno',
  // AI enriched metadata
  'debates.moreFilters': 'Altri filtri',
  'debates.aiInsights': 'Approfondimenti IA',
  'debates.sentiment': 'Sentimento',
  'debates.position': 'Posizione',
  'debates.for': 'A favore',
  'debates.against': 'Contrario',
  'debates.positive': 'Positivo',
  'debates.negative': 'Negativo',
  'debates.amendments': 'emendamenti',
  'debates.proposed': 'proposti',
  'debates.stanceSummary': 'Sintesi della posizione',
  'debates.federal': 'Federale',
  'debates.cantonal': 'Cantonale',
  'debates.federalismStance': 'Posizione federalista',
  'debates.federalTip': "L'oratore sostiene di regolamentare questo a livello federale (centralizzato) invece di lasciarlo ai cantoni.",
  'debates.cantonalTip': "L'oratore sostiene di lasciare questo ai cantoni (decentralizzato) invece di regolamentarlo a livello federale.",
  'debates.emotionality': 'Emotività',
  'debates.allRoles': 'Ruoli',
  'debates.allSentiments': 'Sentimenti',
  'debates.allPositions': 'Posizioni',
  'debates.allFederalism': 'Federalismo',
  'debates.federalism': 'Federalismo',
  // Codici di ruolo non ancora coperti sotto (vedi lib/debateEnums.ts).
  'debates.role.rapporteur': 'Relatore',
  'debates.role.procedural': 'Procedura',
  'debates.amendmentOnly': 'Emendamento proposto',
  'debates.conditionalSupport': 'Sostegno condizionato',
  'debates.role.proponent': 'Sostenitore',
  'debates.role.critic': 'Critico',
  'debates.role.expert': 'Esperto',
  'debates.role.mediator': 'Mediatore',
  'debates.role.stateRep': 'Rappresentante statale',
  'common.neutral': 'Neutro',
  // bills
  'bills.title': 'Oggetti parlamentari',
  'bills.subtitle': 'Cerca e sfoglia gli oggetti parlamentari.',
  'bills.searchPlaceholder': 'Cerca oggetti per parola chiave o numero…',
  'bills.semanticMode': 'Ricerca semantica',
  'bills.browseMode': 'Navigazione strutturata',
  'bills.type.motion': 'Mozione',
  'bills.type.postulate': 'Postulato',
  'bills.type.interpellation': 'Interpellanza',
  'bills.type.parlInit': 'Iniziativa parlamentare',
  'bills.type.cantonInit': 'Iniziativa cantonale',
  'bills.type.groupMotion': 'Mozione di gruppo',
  'bills.type.question': 'Interrogazione',
  'bills.type.urgentQuestion': 'Interrogazione urgente',
  'bills.type.simpleQuestion': 'Interrogazione semplice',
  'bills.type.federalBill': 'Messaggio del Consiglio federale',
  'bills.type.urgentInterp': 'Interpellanza urgente',
  'bills.type.urgentSimple': 'Interrogazione urgente semplice',
  'bills.type.recommendation': 'Raccomandazione',
  'bills.type.petition': 'Petizione',
  'bills.type.pag': 'Interrogazione di gruppo parlamentare',
  'bills.status.submitted': 'Depositato',
  'bills.status.referred': 'Trasmesso',
  'bills.status.inCommittee': 'In commissione',
  'bills.status.planned': 'Pianificato',
  'bills.status.finalVote': 'Votazione finale',
  'bills.status.concluded': 'Liquidato',
  'bills.status.reporting': 'Rapporto disponibile',
  'bills.status.statement': 'Dichiarazione disponibile',
  'bills.tab.documents': 'Documenti',
  'bills.tab.relatedBusiness': 'Oggetti correlati',
  'bills.related.linked': 'Legami ufficiali',
  'bills.related.semantic': 'Semanticamente simili',
  'bills.related.noSemantic': 'Nessun oggetto simile trovato.',
  'bills.related.votes': 'Votazioni collegate',
  'bills.tab.related': 'Correlati & Votazioni',
  'bills.tab.fulltext': 'Testo completo',
  'bills.tab.council': 'Consiglio federale',
  'bills.cosignatories': 'Cofirmatari',
  'bills.rapporteurs': 'Relatori',
  'bills.preconsultations': 'Commissioni competenti',
  'bills.legislativeDocs': 'Documenti legislativi',
  'bills.noDocuments': 'Nessun documento legislativo disponibile.',
  'bills.botschaft': 'Messaggio del Consiglio federale (Botschaft)',
  // committees
  'committees.title': 'Commissioni',
  'committees.subtitle': 'Sfoglia le commissioni parlamentari e i loro membri',
  'committees.allCouncils': 'Consigli',
  'committees.allCommissions': 'Commissioni',
  'committees.national': 'Consiglio nazionale',
  'committees.states': 'Consiglio degli Stati',
  'committees.members': 'membri',
  'committees.function': 'Funzione',
  'committees.backToList': 'Torna alle commissioni',
  'committees.searchPlaceholder': 'Cerca per nome o membro…',
  'committees.csv.abbreviation': 'Abbreviazione',
  'committees.csv.name': 'Nome',
  'committees.csv.council': 'Consiglio',
  'committees.csv.type': 'Tipo',
  'committees.csv.members': 'Membri',
  'committees.filterParty': 'Filtra per partito',
  'committees.typeAll': 'Tipi',
  'committees.statusAll': 'Stati',
  'committees.statusActive': 'Attivo',
  'committees.statusInactive': 'Inattivo',
  'committees.typePermanent': 'Permanente',
  'committees.typeSpecial': 'Speciale',
  'committees.typeWorkgroup': 'Gruppo di lavoro',
  'bills.allTypes': 'Tipi',
  'bills.allStatuses': 'Stati',
  'bills.allDepartments': 'Dipartimenti',
  'bills.exportCSV': 'Esporta i risultati filtrati come CSV',
  'bills.moreFilters': 'Altri filtri',
  'bills.numberFilter': 'Numero (es. 23.4488)',
  'bills.aiFilters': 'Filtri aggiuntivi',
  'bills.aiFilters.primaryTopic': 'Temi',
  'bills.aiFilters.subTopic': 'Sotto-temi',
  'bills.aiFilters.intent': 'Intenzioni',
  'bills.aiFilters.audience': 'Destinatari',
  'bills.aiFilters.trigger': 'Fattori scatenanti',
  // Traduzioni dei valori enum IA (il backend memorizza l'inglese canonico;
  // localizzato solo per la visualizzazione, il valore canonico viene inviato
  // all'API).
  'affairs.intent.newLegislation':  'Nuova legislazione',
  'affairs.intent.revision':        'Revisione / Modifica',
  'affairs.intent.repeal':          'Abrogazione / Soppressione',
  'affairs.intent.executive':       'Istruzione esecutiva',
  'affairs.intent.reporting':       'Rapporto / Inchiesta',
  'affairs.intent.intlAdaptation':  'Adeguamento internazionale',
  'affairs.audience.citizens':         'Cittadini (generale)',
  'affairs.audience.smes':             'PMI / economia locale',
  'affairs.audience.largeEnterprises': 'Grandi imprese',
  'affairs.audience.publicAdmin':      'Amministrazione pubblica',
  'affairs.audience.vulnerable':       'Persone vulnerabili',
  'affairs.audience.farmers':          'Agricoltura',
  'affairs.audience.healthcare':       'Sanità',
  'affairs.audience.education':        'Formazione',
  'affairs.trigger.popularInitiative':  'Iniziativa popolare / Referendum',
  'affairs.trigger.intlMandates':       'Mandati internazionali (UE/OCSE/ONU)',
  'affairs.trigger.judicialRulings':    'Sentenze giudiziarie',
  'affairs.trigger.techShift':          'Cambiamento tecnologico',
  'affairs.trigger.globalCrisis':       'Crisi globale',
  'affairs.trigger.internalInitiative': 'Iniziativa interna',
  'bills.aiFilters.minImpact': 'Impatto ≥',
  'bills.aiFilters.minSensitivity': 'Sensibilità ≥',
  'bills.aiFilters.minCentralization': 'Centralizzazione ≥',
  'bills.aiFilters.browseOnly': 'I filtri IA si applicano solo in modalità esplorazione',
  'bills.intelligence.title': 'Analisi IA',
  'bills.quickStart.title': 'Esplora — o usa la ricerca sopra',
  'bills.quickStart.byYear': 'Per anno',
  'bills.submittedBy': 'Presentato da…',
  'bills.timeline.submitted': 'Depositato',
  'bills.timeline.preconsultation': 'Preconsultazione',
  'bills.timeline.parliamentaryVote': 'Votazione parlamentare',
  // votes
  'votes.title': 'Votazioni',
  'votes.subtitle': 'Sfoglia i riepiloghi delle votazioni parlamentari.',
  'votes.councilScope.title': 'Solo Consiglio nazionale',
  'votes.councilScope.tooltip': 'Questi dati coprono solo i voti nominali del Consiglio nazionale. Anche il Consiglio degli Stati pubblica i voti individuali, ma tramite una fonte separata non inclusa nell’API dei voti del Parlamento che sincronizziamo.',
  'votes.subtitleBusiness':  'Sfoglia le votazioni raggruppate per oggetto.',
  'votes.allCouncils': 'Consigli',
  'votes.dataCoverageNote': 'Nota: le votazioni per appello nominale del Consiglio degli Stati sono disponibili dal 2022, quelle del Consiglio nazionale dalla legislatura 50 (2015). Le legislature precedenti vengono aggiunte progressivamente.',
  'votes.bothCouncils': 'Entrambi i consigli hanno votato su questo oggetto',
  'votes.oneCouncil': 'Solo il {council} ha votato su questo oggetto',
  'votes.chamberSwitchHint': 'Ogni consiglio vota separatamente — cambia per vedere i membri dell’altro consiglio',
  'votes.subtitleHeatmap':   'Matrice gruppo × voto — individuare i gruppi che si dividono o si allineano.',
  'votes.subtitleAnalytics': 'Analisi di coesione, confronto, dissidenza e demografia sul registro dei voti.',
  'votes.analytics.keywordTooltip': 'Restringe i voti sottostanti per titolo o oggetto — es. "clima" limita l\'analisi ai voti legati al clima.',
  'votes.analytics.businessNumberPlaceholder': 'N° oggetto (es. 25.482)',
  'votes.analytics.businessNumberTooltip':     'Restringe l\'analisi ai voti su questo specifico oggetto.',
  'votes.analytics.scope.totalVotes':    'voti',
  'votes.analytics.scope.finalVote':     'votazione finale',
  'votes.analytics.scope.finalTooltip':  'Partecipazione consolidata su tutti i {events} eventi di voto per l\'oggetto {bnum}. Clicca per aprire la votazione finale / principale.',
  'votes.tab.search': 'Ricerca',
  'votes.viewEvents': 'Eventi di voto',
  'votes.viewBusiness': 'Per oggetto',
  'votes.votingEvents': 'votazioni',
  'votes.searchPlaceholder': 'Cerca per titolo, oggetto o numero dell\'oggetto (es. 25.041)…',
  'votes.businessNumberPlaceholder': 'N. oggetto (es. 25.3293)',
  'votes.passed': 'Approvato',
  'votes.rejected': 'Respinto',
  'votes.pending': 'In sospeso',
  'votes.outcome.accepted': 'Progetto approvato',
  'votes.outcome.rejected': 'Progetto respinto',
  'votes.yes': 'Sì',
  'votes.no': 'No',
  'votes.abstain': 'Astensione',
  'votes.present': 'Presente',
  'votes.notPresent': 'Assente',
  'votes.excused': 'Giustificato',
  'votes.breakdown': 'Ripartizione per gruppo',
  'votes.partyBreakdown': 'Ripartizione per partito',
  'votes.individualVotes': 'Voti individuali',
  'votes.councillors': 'consiglieri',
  'votes.showAll': 'Mostra tutti',
  'votes.againstFaction': 'Contro il gruppo',
  'votes.seeDebates': 'Vedi dibattiti',
  'votes.surpriseFilter': 'Gruppo diviso',
  'votes.tie': 'Parità',
  // Phase 2b — etichette di traduzione per voti invertiti
  // (votazioni finali su iniziative popolari, voti procedurali per parole chiave).
  'votes.invertedBadge': 'Voto invertito',
  'votes.invertedTooltip.popularInitiative': 'Nelle votazioni finali sulle iniziative popolari, il Parlamento vota su un decreto che raccomanda il rigetto — un Sì adotta il decreto di rigetto (= contro l\'iniziativa); un No respinge il decreto (= a favore dell\'iniziativa).',
  'votes.invertedTooltip.keywordMatch': 'La domanda è formulata in modo che un Sì significhi l\'azione negativa (rigetto / non entrata / nessun seguito) — leggere Sì come Contro il progetto e No come A favore del progetto.',
  'votes.invertedTooltip.generic': 'In questa riga, Sì e No si leggono nella direzione opposta rispetto alla posizione politica sul progetto sottostante.',
  'votes.forBill': 'A favore',
  'votes.againstBill': 'Contro',
  'votes.rawMechanicsTooltip': 'Conteggi grezzi Sì/No — meccanica del voto, non posizione. Vedi la riga A favore/Contro sopra per la posizione tradotta sul progetto.',
  'votes.rawDecisionLabel': 'Voto grezzo',
  'filter.allStances': 'Posizioni',
  'filter.tooltip.logicalStance': 'Filtra per posizione tradotta sul progetto. Impostato dalla navigazione del chatbot; cancellare o cambiare qui.',
  'votes.date': 'Data',
  'votes.passRate': 'Tasso di adozione',
  'votes.contestedSub': '≤10 voti di scarto',
  'votes.perVote': 'consiglieri / voto',
  'votes.contested': 'Voti ravvicinati',
  'votes.avgParticipation': 'Partecipazione media',
  'votes.closestMargin': 'Margine più stretto',
  'votes.closeVotesFilter': 'Voti ravvicinati',
  'votes.finalVoteFilter':  'Votazioni finali',
  'votes.finalVoteTag':     'Votazione finale',
  'votes.finalVoteTooltip': 'Votazione finale sull\'oggetto',
  'votes.meaning.yes':         'Sì',
  'votes.meaning.no':          'No',
  'votes.meaning.yesAccept':   'Un Sì accetta il progetto.',
  'votes.meaning.noReject':    'Un No respinge il progetto.',
  'votes.meaning.yesReject':   'Un Sì respinge l\'oggetto.',
  'votes.meaning.noAccept':    'Un No accetta l\'oggetto.',
  'votes.meaning.stichYes':    'Sì sostiene una delle due proposte.',
  'votes.meaning.stichNo':     'No sostiene l\'altra proposta.',
  'votes.meaning.yesGeneric':  'Un Sì approva la proposta messa ai voti.',
  'votes.meaning.noGeneric':   'Un No respinge la proposta messa ai voti.',
  'votes.meaning.invertedNote':'Attenzione: in questa votazione il significato di Sì/No è invertito rispetto all\'oggetto.',
  'votes.meaning.stichNote':   'Ballottaggio: Sì e No rappresentano ciascuno una proposta concorrente, non l\'accettazione o il rifiuto.',
  'filter.tooltip.finalOnly': 'Mostra solo votazioni finali — i voti procedurali e articolo per articolo sono esclusi.',
  'votes.councillorFilter': 'Consigliere',
  'votes.decisionFilter':   'Decisione',
  'votes.meaningYesFilter': 'Sì significa',
  'votes.speechAlignment':  'Posizione discorso',
  'votes.speechSentiment':  'Sentimento discorso',
  'votes.viewHeatmap': 'Mappa di calore',
  'votes.viewAnalytics': 'Analitica',
  'votes.heatmapEmpty': 'Nessun dato disponibile.',
  'votes.factionCol': 'Gruppo',
  // analytics tab
  'votes.analytics.modes.cohesion':     'Coesione',
  'votes.analytics.modes.comparison':   'Confronto',
  'votes.analytics.modes.rebels':       'Dissidenti',
  'votes.analytics.modes.demographics': 'Demografia',
  'votes.analytics.allYears':            'Anni',
  'votes.analytics.since':               'Dal',
  'votes.analytics.yearFromTooltip':     'Solo voti a partire da quest\'anno',
  'votes.analytics.keywordPlaceholder':  'Filtra per parola chiave…',
  'votes.analytics.cohesion.overallLabel':   'Coesione media',
  'votes.analytics.cohesion.overallTooltip': 'Quota media dei membri del gruppo che votano con la maggioranza, sull\'insieme dei voti filtrati.',
  'votes.analytics.cohesion.acrossVotes':    'su {n} voti',
  'votes.analytics.cohesion.unanimousLabel': 'Unanime',
  'votes.analytics.cohesion.unanimousSub':   '100% coesione',
  'votes.analytics.cohesion.unanimousTooltip': 'Voti in cui il gruppo era del tutto compatto — tutti i membri hanno votato allo stesso modo (100% di coesione).',
  'votes.analytics.cohesion.splitLabel':     'Diviso',
  'votes.analytics.cohesion.splitSub':       '<80% coesione',
  'votes.analytics.cohesion.splitTooltip':   'Voti in cui il gruppo era diviso — meno dell\'80% ha votato con la maggioranza del proprio gruppo.',
  'votes.analytics.cohesion.totalVotesLabel':'Voti totali',
  'votes.analytics.cohesion.totalVotesTooltip':'Numero di voti inclusi in questa analisi dopo i filtri qui sopra.',
  'votes.analytics.cohesion.trendTitle':     'Coesione nel tempo',
  'votes.analytics.cohesion.rankedTitle':    'Voti più coesi',
  'votes.analytics.comparison.pickFactions': 'Gruppi',
  'votes.analytics.comparison.overallTitle': 'Coesione complessiva per gruppo',
  'votes.analytics.comparison.trendTitle':   'Tendenza annuale di coesione',
  'votes.analytics.comparison.factionCol':   'Gruppo',
  'votes.analytics.comparison.cohesionCol':  'Coesione',
  'votes.analytics.comparison.totalVotesCol':'Voti',
  'votes.analytics.comparison.unanimousCol': 'Unanime',
  'votes.analytics.comparison.splitCol':     'Diviso',
  'votes.analytics.rebels.title':            'Dissidenti più frequenti',
  'votes.analytics.rebels.allFactions':      'Gruppi',
  'votes.analytics.rebels.minVotes':         'min. {n} voti',
  'votes.analytics.rebels.defections':       'dissidenze',
  'votes.analytics.rebels.tooltip':          'Una dissidenza è un voto contro la maggioranza del proprio gruppo parlamentare. Il tasso è la quota dei voti di un membro che si discostano dal gruppo.',
  'votes.analytics.demographics.title':      'Comportamento di voto per gruppo',
  'votes.analytics.demographics.bucketCol':  'Gruppo',
  'votes.analytics.demographics.yesShareCol':'Quota Sì',
  'votes.analytics.demographics.yesShareTooltip':'Quota dei voti espressi da questo gruppo (Sì, No e astensioni) che erano Sì.',
  'votes.analytics.demographics.yes':        'Sì',
  'votes.analytics.demographics.no':         'No',
  'votes.analytics.demographics.abstain':    'Astensione',
  'votes.analytics.demographics.total':      'Totale',
  'votes.analytics.demographics.groupBy.faction': 'Per gruppo',
  'votes.analytics.demographics.groupBy.party':   'Per partito',
  'votes.analytics.demographics.groupBy.canton':  'Per cantone',
  'votes.analytics.demographics.groupBy.gender':  'Per genere',
  'votes.analytics.demographics.groupBy.council': 'Per consiglio',
  'votes.analytics.demographics.groupBy.tenure':  'Novizi vs. veterani',
  // sessions
  'sessions.title': 'Sessioni',
  'sessions.subtitle': 'Cerca le sessioni parlamentari, raggruppate per anno.',
  'sessions.subtitleFiltered': '{count} sessioni · {filters}',
  'sessions.live': 'In diretta',
  'sessions.lp': 'LP',
  'sessions.legislativePeriod': 'Legislatura',
  'sessions.passedTooltip': "Quota delle votazioni sostanziali della sessione in cui il progetto è stato accettato. Contano solo le votazioni che decidono su un progetto — quelle procedurali e di spareggio sono escluse, e le votazioni in cui un «Sì» respinge di fatto una proposta sono conteggiate in base al risultato effettivo.",
  'sessions.passedTooltipBasis': 'Basato su {decided} votazioni sostanziali su {total} tenute.',
  'sessions.meetings': 'Sedute',
  'sessions.agenda': 'Sedute & Ordine del giorno',
  'sessions.votes': 'Votazioni',
  'sessions.agendaItems': 'Punti all\'ordine del giorno',
  'sessions.totalYes': 'Totale sì',
  'sessions.totalNo': 'Totale no',
  'sessions.voteCount': 'Numero votazioni',
  'sessions.backToSessions': 'Torna alle sessioni',
  'sessions.noSubjects': 'Nessun punto all\'ordine del giorno.',
  'sessions.noMeetings': 'Nessun dato di seduta disponibile.',
  'sessions.totalVotesCast': 'Voti totali espressi',
  'sessions.voteList': 'Elenco votazioni',
  'sessions.spring': 'Primavera',
  'sessions.summer': 'Estate',
  'sessions.autumn': 'Autunno',
  'sessions.winter': 'Inverno',
  'sessions.special': 'Sessione speciale',
  'sessions.allSeasons': 'Sessioni',
  'sessions.yesNo': 'Sì / No',
  'sessions.liveBannerTitle': 'Il parlamento è in sessione',
  'sessions.liveBannerEnds': 'Fine',
  'sessions.attendance': 'Presenze',
  'sessions.attendanceTip': 'Consiglieri classificati per tasso di assenza in questa sessione. Filtrare per gruppo per restringere la lista.',
  'sessions.attendanceEmpty': 'Nessun dato di voto individuale disponibile per questa sessione.',
  'sessions.calendarGrid': 'Calendario della sessione',
  'sessions.items': 'oggetti',
  'session.discussion.topSpeakers': 'Oratori più attivi',
  'session.discussion.summary':     'Sintesi del dibattito',
  'session.discussion.speeches':    'interventi',
  'session.discussion.avgEmotion':  'Ø emotività',
  'session.topics.policyAreas':     'Ambiti politici',
  'session.topics.keywords':        'Temi principali di questa sessione',
  // parties
  'parties.title': 'Partiti & Gruppi',
  'parties.subtitle': 'Distribuzione seggi, parità di genere e appartenenza alle camere.',
  'parties.activeMembers': 'Membri attivi',
  'parties.nationalCouncil': 'Consiglio nazionale',
  'parties.statesCouncil': 'Consiglio degli Stati',
  // Faction code → recognisable party short-name (unity-ranking axis labels)
  'faction.party.V':   'UDC',
  'faction.party.S':   'PS',
  'faction.party.G':   'Verdi',
  'faction.party.GL':  'PVL',
  'faction.party.RL':  'PLR',
  'faction.party.M-E': 'Il Centro',
  'faction.party.BD':  'PBD',
  'parties.femalePct': '% donne',
  'parties.malePct': '% uomini',
  'parties.seatDistribution': 'Ripartizione seggi per gruppo',
  'parties.nrSrSplit': 'Distribuzione per camera e gruppo',
  'parties.genderByFaction': 'Genere per gruppo',
  'parties.femalePctByFaction': '% donne per gruppo',
  'parties.factionDetails':      'Dettagli gruppi',
  'parties.ideologicalSpectrum': 'Spettro ideologico (Sinistra ↔ Destra)',
  'parties.spectrum.expert': 'Consenso esperti',
  'parties.spectrum.data': 'Dati di voto',
  'parties.spectrum.dataNote': 'calcolato dall\'accordo di voto a coppie tra i gruppi parlamentari',
  'parties.spectrum.dataTip': 'Posizione sull\'asse sinistra-destra derivata dai comportamenti di voto effettivi — similarità di voto di ogni gruppo con UDC (destra) vs PS (sinistra), normalizzata su [−3, +3].',
  'parties.seats': 'Seggi',
  'parties.female': 'Donne',
  'parties.parties': 'Partiti',
  'parties.viewMembers': 'Vedi',
  'parties.cohesion':    'Coesione',
  'parties.cantonDistribution': 'Distribuzione cantonale',
  'parties.dominantFaction': 'Gruppo dominante',
  // parties — tabs
  'parties.tab.assembly': 'Assemblea federale attuale',
  'parties.tab.assemblyTip': "L'Assemblea federale attuale — il Consiglio nazionale e il Consiglio degli Stati insieme. Mostra il gruppo parlamentare dominante per cantone e dove siede ogni membro nelle due camere.",
  'parties.tab.factions': 'Gruppi',
  'parties.tab.factionsTip': 'Un gruppo parlamentare può riunire membri di più partiti. Es. EVP e l\'Alleanza del Centro siedono nel gruppo M-E.',
  'parties.tab.parties': 'Partiti politici',
  'parties.tab.partiesTip': 'Partiti politici come organizzazioni registrate. Il gruppo di un membro può differire dal suo partito se più partiti condividono un gruppo.',
  // parties — map
  'parties.mapTooltipSeats': 'seggi',
  'parties.factionFilterTip': 'Evidenzia uno o più gruppi parlamentari in entrambe le camere; gli altri vengono attenuati.',
  'parties.mapTooltipDominant': 'Dominante',
  'parties.mapClickHint': 'Clicca su un cantone per evidenziare i suoi membri nei piani dei seggi qui sotto',
  // parties — faction card / drill-down
  'parties.viewFaction': 'Profilo gruppo →',
  'parties.noFactions':  'Nessun dato sui gruppi disponibile.',
  'parties.nonAligned':  'Non iscritto / Senza partito',
  // parties — political parties tab
  'parties.party.active': 'attivo',
  'parties.party.founded': 'Fondato',
  'parties.party.dissolved': 'Sciolto',
  'parties.party.noParties': 'Nessun dato sui partiti disponibile.',
  'parties.party.historical':     'Storico',
  'parties.party.showHistorical': 'Mostra partiti storici',
  'parties.party.hideHistorical': 'Nascondi partiti storici',
  // parties — KPI cards
  'parties.kpiSubtitle': 'Totali parlamentari per tutti i gruppi',
  'parties.genderBalance': 'Equilibrio di genere',
  'parties.avgCohesion': 'Coesione media',
  'parties.acrossFactionsNote': 'su tutti i gruppi',
  // parties — chart card titles
  'parties.dominantFactionByCanton': 'Gruppo dominante per cantone',
  'parties.nrSeatsByFaction': 'Consiglio nazionale — Ripartizione seggi per gruppo',
  'parties.srSeatsByFaction': 'Consiglio degli Stati — Ripartizione seggi per gruppo',
  'parties.dominantPartyByCanton': 'Partito dominante per cantone',
  'parties.nrSeatsByParty': 'Consiglio nazionale — Ripartizione seggi per partito',
  'parties.srSeatsByParty': 'Consiglio degli Stati — Ripartizione seggi per partito',
  'parties.dominantFactionByCantonTip': 'Il gruppo parlamentare più forte in ogni cantone per numero di seggi. Clicca su un cantone per evidenziare i suoi membri nei piani dei seggi qui sotto.',
  'parties.hemicycleTip': 'Ogni punto è un seggio, disposto per gruppo parlamentare da sinistra a destra. Passa il mouse su un punto o clicca su un gruppo nella legenda per isolarlo.',
  'parties.genderByFactionTip': 'Quota di donne in ogni gruppo parlamentare. La linea tratteggiata indica la media dell\'intero parlamento.',
  'parties.nrSrSplitTip': 'Come si suddividono i seggi di ogni gruppo parlamentare tra Consiglio nazionale e Consiglio degli Stati. Attiva la «vista %» per confrontare le quote invece dei seggi assoluti.',
  'parties.seatingTip': 'La vera pianta dell’aula — ogni parlamentare al suo seggio reale, secondo la pianta ufficiale dei seggi del Parlamento. Passa il mouse su un seggio per una panoramica; clicca per aprire il profilo.',
  'parties.seating.seat': 'Seggio',
  'parties.seating.noData': 'Nessun dato sui seggi ancora disponibile',
  'parties.seating.canton': 'Cantone',
  'parties.seating.since': 'In parlamento dal',
  'parties.seating.years': 'anni',
  'parties.seating.role': 'Funzione',
  'parties.seating.participation': 'Partecipazione ai voti',
  'parties.seating.cohesion': 'Coesione',
  'parties.seating.committees': 'Commissioni',
  'parties.seating.profession': 'Professione',
  'parties.seating.viewProfile': 'Apri il profilo',
  'parties.legislature': 'Legislatura',
  'parties.current': 'attuale',
  'parties.seatingCurrentBadge': 'Camera attuale',
  'parties.pastLegVoteNote': 'I grafici sul comportamento di voto (coesione, alleanze, spettro ideologico) si basano sui voti per appello nominale registrati della legislatura selezionata, in entrambe le camere ove disponibili (i voti del Consiglio degli Stati sono registrati solo dal 2022).',
  'parties.currentChamberNote': 'Istantanea della camera · legislatura attuale',
  'parties.analyticsSection': 'Composizione & analisi dei voti',
  // parties — ideological spectrum
  'parties.naExcluded': 'Non iscritti (NA) esclusi — indipendenti senza posizione ideologica condivisa.',
  'parties.allianceMatrix': 'Matrice delle alleanze tra gruppi',
  'parties.allianceMatrixTip': 'Percentuale di voti in cui entrambi i gruppi hanno votato allo stesso modo. 100% = sempre insieme, 0% = sempre opposti.',
  'parties.allianceMatrixNote': 'Basato su tutti i voti registrati.',
  'parties.cohesionTrend': 'Unità dei gruppi nel tempo',
  'parties.partyUnityTrend': 'Unità dei partiti nel tempo',
  'parties.cohesionTrendTip': 'Unità di voto dei gruppi per sessione parlamentare.',
  'parties.spectrumClosest': 'Ideologicamente più vicini:',
  'parties.spectrumFurthest': 'Più distanti:',
  'parties.spectrumPtsApart': 'pt di distanza',
  'parties.spectrumGapNote': 'Divario esperti↔voti',
  'parties.votesMoreRight': 'vota più a destra del percepito',
  'parties.votesMoreLeft': 'vota più a sinistra del percepito',
  // parties — gender chart
  'parties.genderAvgLine': 'Media parlamento',
  'parties.genderAvgTooltip': 'Media femminile a livello parlamentare',
  // parties — faction table tooltips
  'parties.seatsShareTooltip': 'Quota di tutti i seggi parlamentari',
  'parties.naChambersNote': 'Membri con ruoli esecutivi (es. Consiglio federale) non assegnati a una camera parlamentare',
  'parties.cohesionTooltip': 'La coesione misura quanto uniformemente vota un gruppo. 100% significa che tutti i membri votano sempre insieme. Valori più bassi indicano divisioni interne. Colore: verde ≥92%, ambra 85–92%, rosso <85%.',
  // parties — party table
  'parties.party.searchPlaceholder': 'Cerca partiti…',
  'parties.party.noCurrentMembers': 'Attualmente non rappresentato in parlamento',
  'parties.party.nameColumn': 'Partito',
  'parties.party.abbrColumn': 'Sigla',
  'parties.party.factionColumn': 'Gruppo',
  'parties.party.factionColumnTitle': 'Gruppo parlamentare di questo partito',
  'parties.party.historicalSubtitle': 'Partiti con una data di scioglimento registrata — include fusioni, rinominazioni e organizzazioni disciolte.',
  // parties — historical era labels
  'parties.party.era.pre1960': 'Prima del 1960',
  'parties.party.era.196070': 'Anni \'60–\'70',
  'parties.party.era.198090': 'Anni \'80–\'90',
  'parties.party.era.2000s': 'Anni 2000–inizio 2010',
  'parties.party.era.present': '2015 — oggi',
  'parties.party.singular': 'partito',
  'parties.party.plural': 'partiti',
  // faction detail page
  'faction.backToParties': 'Torna ai partiti',
  'faction.overview': 'Panoramica',
  'faction.members': 'Membri',
  'faction.interests': 'Lobbying & Interessi',
  'faction.statsNR': 'Consiglio nazionale',
  'faction.statsSR': 'Consiglio degli Stati',
  'faction.statsFemale': 'Donne',
  'faction.statsMale': 'Uomini',
  'faction.memberCount': 'membri',
  'faction.interestsByType': 'Interessi per tipo',
  'faction.topOrganizations': 'Principali organizzazioni',
  'faction.paid': 'Retribuito',
  'faction.unpaid': 'Non retribuito',
  'faction.noInterests': 'Nessun dato di lobbying disponibile per questo gruppo.',
  'faction.councillorsCount': 'consiglieri',
  'faction.cantonBreakdown': 'Membri per cantone',
  'faction.recentVotes':     'Votazioni recenti',
  'faction.factionVote':     'Voto del gruppo',
  // overview
  'overview.title': 'Parlumina',
  'overview.subtitle': 'Dati in tempo reale dall\'Assemblea federale.',
  'overview.councillors': 'Consiglieri',
  'overview.activeAffairs': 'Oggetti in corso',
  'overview.votesThisYear': 'Votazioni quest\'anno',
  'overview.currentSession': 'Sessione attuale',
  'overview.activityTrends': 'Tendenze attività',
  'overview.votesBySession': 'Voti per sessione',
  'overview.partyComposition': 'Composizione partiti',
  'overview.recentDebates': 'Dibattiti recenti',
  'overview.passRate': 'Tasso di adozione (anno)',
  'overview.viewAll': 'Vedi tutti',
  'overview.sessionLive': 'In diretta',
  'overview.sessionEnded': 'terminata',
  'overview.sessionUpcoming': 'inizia tra',
  'overview.speeches': 'interventi',
  'overview.seats': 'Seggi',
  'overview.hotTopics': 'Discussi di recente',
  'overview.allLang': 'Tutti',
  'overview.vsLastSession': 'vs. ultima sessione',
  'overview.ofVotes': 'su {n} voti',
  'overview.nrSrSplit': '{nr} CN · {sr} CS · +{br} CF · +{bk} CaF',
  'overview.submittedThisYear': '{n} presentate quest\'anno',
  'overview.allChambers': 'tutte le camere',
  'overview.vsYear': 'vs. {year}',
  'overview.highImpactBills': 'Disegni ad alto impatto',
  'overview.viewDetails': 'Vedi dettagli',
  'overview.federalPush': 'Spinta federale',
  'overview.balanced': 'Equilibrato',
  'overview.cantonalLean': 'Orientamento cantonale',
  'overview.impactTooltipTitle': 'Impatto legislativo',
  'overview.impactTooltipText': 'Quanto questo disegno modifica il diritto svizzero o la politica pubblica. Valutato 1–10 dall\'IA.',
  'overview.sensitivityTooltipTitle': 'Sensibilità politica',
  'overview.sensitivityTooltipText': 'Grado di controversia politica o tensione tra partiti generata da questo disegno. Valutato 1–10 dall\'IA.',
  'overview.chart.clickToOpenSession': 'Clicca per aprire la sessione',

  // Members table headers (4.8 — gap fixes)
  'member.council': 'Camera',
  'member.age':     'Età',

  // Bills — type-tooltip descriptions (4.8 — gap fixes)
  'bills.type.tip.motion':            'Mozione — incarico vincolante al Consiglio federale di presentare un disegno di legge o di agire.',
  'bills.type.tip.postulate':         'Postulato — raccomandazione non vincolante al Consiglio federale di esaminare un tema.',
  'bills.type.tip.interpellation':    'Interpellanza — domande scritte al Consiglio federale che richiedono una risposta scritta formale.',
  'bills.type.tip.parlInitiative':    'Iniziativa parlamentare — un membro propone direttamente un disegno di legge senza coinvolgere il Consiglio federale.',
  'bills.type.tip.cantonInitiative':  'Iniziativa cantonale — un cantone propone una modifica costituzionale o legislativa federale.',
  'bills.type.tip.groupMotion':       'Mozione di gruppo — mozione presentata congiuntamente da un intero gruppo parlamentare.',
  'bills.type.tip.simpleQuestion':    'Interrogazione semplice — breve domanda scritta al Consiglio federale.',
  'bills.type.tip.federalCouncilBill':'Disegno del Consiglio federale — disegno di legge introdotto direttamente dall\'esecutivo.',
  'bills.type.tip.urgentInterp':      'Interpellanza urgente — interpellanza che richiede una risposta urgente.',
  'bills.type.tip.urgentSimple':      'Interrogazione semplice urgente — breve domanda scritta urgente al Consiglio federale.',
  'bills.type.tip.urgentQuestion':    'Domanda urgente — richiede una risposta immediata del Consiglio federale.',
  'bills.type.tip.recommendation':    'Raccomandazione — raccomandazione non vincolante a una commissione o autorità.',
  'bills.type.tip.petition':          'Petizione — richiesta presentata al parlamento dai cittadini.',
  'bills.type.tip.parlGroupMotion':   'Mozione di gruppo parlamentare — mozione presentata da un gruppo parlamentare.',

  // Usage page (admin / developer-only cost dashboard)
  'usage.title':                  'Utilizzo',
  'usage.subtitle':               'Consumo di token e costo stimato per tutti i client di chat.',
  'usage.errorLoad':              'Caricamento dati di utilizzo fallito',
  'usage.range.7d':               'Ultimi 7 giorni',
  'usage.range.30d':              'Ultimi 30 giorni',
  'usage.range.90d':              'Ultimi 90 giorni',
  'usage.range.365d':             'Ultimo anno',
  'usage.kpi.messages':           'Messaggi',
  'usage.kpi.messagesHint':       'Uno per domanda posta',
  'usage.kpi.apiCalls':           'Chiamate API',
  'usage.kpi.apiCallsHint':       'Risposte Anthropic (incl. iterazioni di tool)',
  'usage.kpi.estimatedCost':      'Costo stimato',
  'usage.kpi.costPer100':         '{cost} ogni 100 messaggi',
  'usage.kpi.totalTokens':        'Token totali',
  'usage.kpi.titleGenCost':       'Costo gen. titolo',
  'usage.kpi.cacheHitRate':       'Tasso di cache',
  'usage.kpi.cacheHitRateHint':   '{saved} risparmiati · {eff} del prefisso cacheable colpito',
  'usage.col.hitRate':            'Tasso di cache',
  'usage.kpi.titleGenHint':       'Groq Llama 3.1 8B',
  'usage.kpi.users':              'Utenti',
  'usage.legend.input':           'Input',
  'usage.legend.output':          'Output',
  'usage.legend.cacheRead':       'Cache letto',
  'usage.legend.cacheCreate':     'Cache scritto',
  'usage.perModelTitle':          'Per modello (agente di chat)',
  'usage.col.model':              'Modello',
  'usage.col.msgs':               'Mess.',
  'usage.col.input':              'Input',
  'usage.col.output':             'Output',
  'usage.col.cacheRead':          'Cache letto',
  'usage.col.cacheCreate':        'Cache scritto',
  'usage.col.estCost':            'Costo stim.',
  'usage.unknownModel':           'sconosciuto',
  'usage.titleGenTitle':          'Generazione di titolo',
  'usage.titleGenNote':           '(Groq, fornitore separato)',
  'usage.titleGen.col.sessionsTitled':    'Sessioni titolate',
  'usage.titleGen.col.promptTokens':      'Token prompt',
  'usage.titleGen.col.completionTokens':  'Token completion',
  'usage.pillLabelTitle':                 'Etichette dei filtri',
  'usage.pillLabelNote':                  '(Groq, per turno — rifinitura UI)',
  'usage.pillLabel.col.turnsLabelled':    'Turni etichettati',
  'usage.perUserTitle':           'Per utente',
  'usage.perUserCount':           '({count} totali)',
  'usage.showMore':               'Mostra altri {count}',
  'usage.collapse':               'Comprimi',
  'usage.user.col.user':          'Utente',
  'usage.user.col.sessions':      'Sessioni',
  'usage.user.col.messages':      'Messaggi',
  'usage.user.col.apiCalls':      'Chiamate API',
  'usage.user.col.cacheRW':       'Cache L/S',
  'usage.user.col.costPer100':    '$ / 100 messaggi',
  'usage.user.col.lastActivity':  'Ultima attività',
  'usage.user.nameUnknown':       'nome sconosciuto',
  'usage.footnote':               'Messaggio = uno scambio di conversazione: la domanda dell\'utente + tutte le iterazioni interne degli strumenti + la risposta finale dell\'IA, contati come uno. Chiamate API è il conteggio grezzo delle risposte Anthropic (≥ messaggi, poiché l\'agente emette una chiamata API per iterazione). Costo e token sono sommati su tutte le chiamate. $ / 100 messaggi è la proiezione di budget — al costo attuale per messaggio, quanto costerebbero 100 messaggi? Solo stime — la fattura effettiva del fornitore può differire. Generazione di titolo: Groq Llama 3.1 8B Instant ($0.05 / $0.08 per M). Agente di chat: Anthropic Claude Haiku 4.5 ($1 input / $5 output per M, letture cache $0.10, scritture cache 5 min $1.25).',

  // ── Pagina Impostazioni ────────────────────────────────────────────────────
  'settings.title':                  'Impostazioni',
  'settings.subtitle':               'Gestisci preferenze, notifiche e dati di sistema.',
  'settings.manageAccount':          'Gestisci account',
  'settings.tab.preferences':        'Preferenze',
  'settings.tab.notifications':      'Notifiche',
  'settings.tab.managePresets':      'Gestisci filtri',
  'settings.tab.system':             'Sistema',
  'settings.appearance':             'Aspetto',
  'settings.theme':                  'Tema',
  'settings.theme.desc':             'Schema cromatico della dashboard.',
  'settings.theme.light':            'Chiaro',
  'settings.theme.dark':             'Scuro',
  'settings.theme.system':           'Sistema',
  'settings.language':               'Lingua',
  'settings.language.desc':          'Lingua per le etichette dei dati e l\'interfaccia.',
  'settings.navigation':             'Navigazione',
  'settings.landingPage':            'Pagina iniziale predefinita',
  'settings.landingPage.desc':       'Pagina mostrata dopo l\'accesso.',
  'settings.aiChat':                 'Chat IA',
  'settings.showWidget':             'Mostra widget di chat',
  'settings.showWidget.desc':        'Mostra l\'assistente InnoChat su tutte le pagine.',
  'settings.about':                  'Informazioni',
  'settings.appVersion':             'Versione app',
  'settings.appVersion.desc':        'Parlumina',
  'settings.dataSource':             'Fonte dati',
  'settings.dataSource.desc':        'Dati aperti dell\'Assemblea federale svizzera.',
  'settings.dataUpdated':            'Dati aggiornati',
  'settings.dataUpdated.desc':       'Record più recente sincronizzato dal registro parlamentare.',
  'settings.dataUpdated.unknown':    'Sconosciuto',
  'settings.aiAssistant':            'Assistente IA',
  'settings.aiAssistant.desc':       'Sviluppato con INNOCHAT — la piattaforma IA di InnoQ.',
  'settings.alertPrefs':             'Preferenze di avviso',
  'settings.alert.votes':            'Esiti delle votazioni',
  'settings.alert.votes.desc':       'Notifica quando un oggetto monitorato va alla votazione finale.',
  'settings.alert.bills':            'Cambi di stato degli oggetti',
  'settings.alert.bills.desc':       'Avvisa quando un oggetto monitorato avanza o si conclude.',
  'settings.alert.browser':          'Notifiche del browser',
  'settings.alert.browser.blocked':  'Bloccate dal browser — modifica nelle impostazioni del sito.',
  'settings.alert.browser.desc':     'Abilita le notifiche push in questo browser.',
  'settings.watchlist':              'Lista di osservazione',
  'settings.watchlist.members':      'Membri osservati',
  'settings.watchlist.bills':        'Oggetti osservati',
  'settings.watchlist.empty':        'Nulla di salvato.',
  'settings.watchlist.countOne':     '1 elemento salvato.',
  'settings.watchlist.countMany':    '{n} elementi salvati.',
  'settings.watchlist.manage':       'Gestisci',
  'settings.tags':                   'Tag',
  'settings.presets.signIn':         'Accedi per gestire i tuoi filtri salvati.',
  'settings.presets.title':          'Filtri salvati',
  'settings.presets.empty':          'Nessun filtro salvato. Su Membri, Oggetti, Dibattiti o Votazioni, imposta i filtri desiderati e clicca «Salva filtro» per conservarli qui.',
  'settings.presets.deleteTooltip':  'Elimina filtro',
  'settings.presets.delete':         'Elimina',
  'settings.presets.updated':        'Aggiornato il {date}',
  'settings.presets.countOne':       '1 filtro',
  'settings.presets.countMany':      '{n} filtri',
  'settings.presets.loadError':      'Caricamento filtri non riuscito',
  'settings.presets.deleteError':    'Eliminazione non riuscita',
  'settings.developer':              'Sviluppatore',
  'settings.chatProvider':           'Fornitore del modello del chatbot',
  'settings.chatProvider.label':     'Fornitore attivo',
  'settings.chatProvider.desc':      'Controllo sviluppatore. Determina quale LLM risponde al chatbot per TUTTI gli utenti — non solo per te. Applicato dal turno successivo.',
  'settings.chatProvider.anthropic': 'Anthropic (Claude Sonnet)',
  'settings.chatProvider.openai':    'OpenAI (GPT-5.4 mini)',
  'settings.chatProvider.loadError': "Impossibile caricare il fornitore attuale.",
  'settings.chatProvider.saveError': "Impossibile cambiare fornitore. Riprova.",
  'settings.devInspector':           'Ispettore dev',
  'settings.devInspector.desc':      'Mostra sotto ogni risposta IA le chiamate strumenti, gli argomenti e le anteprime dei risultati dell\'agente. Disattiva per vedere la chat come un utente normale.',
  // citations + speech/vote correlation
  'debates.conditional': 'Condiz.',
  'citation.type.councillor': 'Profilo',
  'citation.type.affair': 'Oggetto',
  'citation.type.dispatch': 'Messaggio',
  'citation.type.speech': 'Intervento',
  'citation.source': 'Fonte',
  'citation.aria': 'Fonte {id}: {label}',
  // chat widget
  'chat.entity.member': 'Consigliere',
  'chat.entity.session': 'Sessione',
  'chat.entity.bill': 'Oggetto',
  'chat.entity.vote': 'Votazione',
  'chat.entity.debate': 'Dibattito',
  'chat.entity.faction': 'Gruppo',
  'chat.context.dashboard': 'Dashboard del Parlamento',
  'chat.viewing': 'Visualizzazione:',
  'chat.context.syncActive': 'L\'assistente sa cosa stai consultando — la pagina corrente, oltre ai filtri applicati e agli elementi aperti.',
  'chat.context.syncInactive': 'Nessun contesto di pagina da condividere qui — l\'assistente risponde a domande generali. Apri una pagina di dati per chiedere su ciò che stai consultando.',
  'chat.toast.newSession': 'Nuova conversazione avviata',
  'chat.fab.aria': 'Apri la chat IA del Parlamento',
  'chat.collapse': 'Comprimi',
  'chat.expand': 'Espandi',
  'chat.newSession': 'Nuova conversazione',
  'chat.mode.speed': 'Veloce',
  'chat.mode.quality': 'Qualità',
  'chat.mode.speedTip': 'Risposte rapide — bassa latenza, buona qualità',
  'chat.mode.qualityTip': 'Qualità migliore — risposte più approfondite, latenza più elevata',
  'chat.dashboardFiltered': 'Dashboard filtrato:',
  'chat.clearFilter': 'Cancella filtro',
  'chat.input.placeholder': 'Fai una domanda sul Parlamento…',
  'chat.input.signingIn': 'Accesso…',
  'chat.send': 'Invia messaggio',
  'chat.stop': 'Interrompi generazione',
  'chat.stopped': 'Interrotto.',
  // multi-select control + canton map tooltip
  'multiselect.selected': '{n} selezionati',
  'multiselect.noOptions': 'Nessuna opzione',
  'cantonMap.dominantParty': 'Partito dominante',
  'cantonMap.faction': 'Gruppo',
  'cantonMap.dominantFaction': 'Gruppo dominante',
  'cantonMap.party': 'Partito',
  // member activity chart
  'common.pp': 'p.p.',
  'member.activity.voteParticipation': 'Partecipazione ai voti',
  'member.activity.participation': 'Partecipazione',
  'member.activity.votesOfTotal': '{n} di {total} voti',
  // localization pass: bill detail / parties / session detail
  'billDetail.typeTip.motion': 'Mozione — incarico vincolante al Consiglio federale di presentare un disegno di legge o di agire.',
  'billDetail.typeTip.postulate': 'Postulato — raccomandazione non vincolante che invita il Consiglio federale a esaminare un tema.',
  'billDetail.typeTip.interpellation': 'Interpellanza — domande scritte al Consiglio federale che richiedono una risposta scritta formale.',
  'billDetail.typeTip.parliamentaryInit': 'Iniziativa parlamentare — un deputato propone un progetto direttamente senza coinvolgere il Consiglio federale.',
  'billDetail.typeTip.cantonalInit': 'Iniziativa cantonale — un Cantone propone una modifica costituzionale o legislativa federale.',
  'billDetail.typeTip.groupMotion': 'Mozione di gruppo — una mozione presentata congiuntamente da un intero gruppo parlamentare.',
  'billDetail.typeTip.simpleQuestion': 'Interrogazione semplice — una breve domanda scritta al Consiglio federale.',
  'billDetail.typeTip.federalCouncilBill': 'Oggetto del Consiglio federale — un disegno presentato direttamente dall\'esecutivo.',
  'billDetail.typeTip.urgentInterpellation': 'Interpellanza urgente — un\'interpellanza che richiede una risposta urgente.',
  'billDetail.typeTip.urgentSimpleQuestion': 'Interrogazione semplice urgente — una breve domanda scritta urgente al Consiglio federale.',
  'billDetail.typeTip.urgentQuestion': 'Interrogazione urgente — richiede una risposta immediata del Consiglio federale.',
  'billDetail.typeTip.recommendation': 'Raccomandazione — una raccomandazione non vincolante a una commissione o autorità.',
  'billDetail.typeTip.petition': 'Petizione — una richiesta presentata al Parlamento dai cittadini.',
  'billDetail.typeTip.parliamentaryGroupMotion': 'Mozione di gruppo parlamentare — una mozione presentata da un gruppo parlamentare.',
  'billDetail.pipeline.submitted': 'Depositato',
  'billDetail.pipeline.review': 'In esame',
  'billDetail.pipeline.vote': 'Votazione finale',
  'billDetail.pipeline.concluded': 'Liquidato',
  'billDetail.tab.debates': 'Interventi',
  'billDetail.tab.activity': 'Attività',
  'billDetail.tab.votes': 'Voti',
  'billDetail.tab.similar': 'Oggetti simili',
  'billDetail.furtherDocs': 'Documenti complementari',
  'billDetail.officialBulletin': 'Bollettino ufficiale',
  'billDetail.notFound': 'Oggetto non trovato.',
  'billDetail.lp.title': 'Legislatura',
  'billDetail.meta.status': 'Stato delle deliberazioni',
  'billDetail.meta.legislativePeriod': 'Legislatura',
  'billDetail.meta.commission': 'Commissione',
  'billDetail.meta.category': 'Categoria di dibattito',
  'billDetail.category.I': 'Dibattito libero',
  'billDetail.category.II': 'Dibattito organizzato',
  'billDetail.category.III': 'Dibattito di gruppo',
  'billDetail.category.IV': 'Dibattito ridotto',
  'billDetail.category.V': 'Procedura ridotta',
  'billDetail.lp.tooltip': 'Il mandato quadriennale dell’Assemblea federale durante il quale i membri eletti restano in carica.',
  'billDetail.triggerTip.popularInitiative': 'Iniziativa popolare — i cittadini possono proporre una modifica della Costituzione federale raccogliendo 100 000 firme valide entro 18 mesi. Referendum — una legge approvata dal Parlamento può essere sottoposta al voto popolare se si raccolgono 50 000 firme entro 100 giorni.',
  'billDetail.triggerTip.intlMandates': 'Determinato da obblighi di organismi internazionali (UE, OCSE, ONU) che la Svizzera deve recepire nel diritto nazionale.',
  'billDetail.triggerTip.judicialRulings': 'Sollecitato da una decisione giudiziaria (ad es. del Tribunale federale o della CEDU) che richiede un adeguamento della legislazione.',
  'billDetail.triggerTip.techShift': 'Una risposta a nuove tecnologie o sviluppi digitali non ancora coperti dal diritto vigente.',
  'billDetail.triggerTip.globalCrisis': 'Innescato da una crisi internazionale (pandemia, guerra, shock finanziario) che richiede una risposta legislativa.',
  'billDetail.triggerTip.internalInitiative': 'Nasce all’interno del Parlamento o dell’amministrazione federale anziché da un evento esterno.',
  'billDetail.triggerTip.generic': 'L’evento o il processo esterno che ha dato origine a questo oggetto parlamentare.',
  'billDetail.tags.label': 'Temi',
  'billDetail.debates.councilFilter': 'Consiglio',
  'billDetail.debates.showingRange': 'Interventi {from}–{to} su {total}',
  'billDetail.debates.pageOf': 'Pagina {page} di {pages}',
  'billDetail.meta.submitted': 'Depositato',
  'billDetail.meta.statusDate': 'Data dello stato',
  'billDetail.description': 'Descrizione',
  'billDetail.noShortDescription': 'Nessuna breve descrizione disponibile per questo oggetto.',
  'billDetail.viewFullText': 'Visualizza il testo integrale',
  'billDetail.submittedTo': 'Depositato presso: ',
  'billDetail.activityTimeline': 'Cronologia delle attività',
  'billDetail.fullText.initialSituation': 'Situazione iniziale',
  'billDetail.fullText.submittedText': 'Testo depositato',
  'billDetail.fullText.reason': 'Motivazione',
  'billDetail.fullText.motion': 'Proposta / Richiesta',
  'billDetail.noFullText': 'Nessun testo integrale disponibile.',
  'billDetail.proposalCode': 'Codice della proposta',
  'billDetail.council.response': 'Parere del Consiglio federale',
  'billDetail.council.proposalText': 'Testo della proposta',
  'billDetail.council.proposal': 'Proposta del Consiglio federale',
  'billDetail.council.proposalCodeTip': "Il codice usato dai dati parlamentari ufficiali per la proposta del Consiglio federale (p. es. 44 = adozione, 45 = reiezione, 46 = adozione parziale). L'etichetta ne indica il significato.",
  'billDetail.council.proceedings': 'Deliberazioni',
  'billDetail.council.noResponse': 'Nessun parere del Consiglio federale disponibile.',
  'billDetail.debates.loadError': 'Impossibile caricare i dibattiti. L\'indice di ricerca potrebbe essere temporaneamente non disponibile.',
  'billDetail.debates.empty': 'Nessun intervento parlamentare trovato per questo oggetto.',
  'billDetail.debates.emptyChamber': 'Nessun intervento di questo consiglio per questo oggetto.',
  'billDetail.votes.emptyChamber': 'Nessun voto di questo consiglio per questo oggetto.',
  'billDetail.debates.stateRep': 'Rappr. del Cantone',
  'billDetail.debates.amendmentProposed': 'Emendamento proposto',
  'billDetail.debates.amendment': 'emendamento',
  'billDetail.debates.emotionality': 'Emotività',
  'parties.noData': 'Nessun dato',
  'parties.totalSuffix': 'in totale',
  'parties.nrSeats': 'seggi CN',
  'parties.srSeats': 'seggi CS',
  'parties.csv.abbreviation': 'Abbreviazione',
  'parties.csv.name': 'Nome',
  'parties.csv.total': 'Totale',
  'parties.csv.nr': 'CN',
  'parties.csv.sr': 'CS',
  'parties.csv.female': 'Donne',
  'parties.csv.male': 'Uomini',
  'parties.csv.cohesion': 'Coesione (%)',
  'parties.csv.activeMembers': 'Membri attivi',
  'parties.csv.founded': 'Fondato',
  'parties.avg': 'Media',
  'parties.spectrum.left': 'Sinistra',
  'parties.spectrum.right': 'Destra',
  'parties.selfAlways100': 'Sé stesso — sempre 100%',
  'parties.agreement': 'Concordanza',
  'parties.recordedVotesCount': '{a} di {b} voti registrati',
  'parties.recordedVotes': 'voti registrati',
  'parties.cohesionAxis': 'Unità (%)',
  'parties.threshold90': 'soglia del 90%',
  'parties.chamber.nr': 'Consiglio nazionale',
  'parties.chamber.sr': 'Consiglio degli Stati',
  'parties.cohesionNoChamberData': 'Nessun dato di coesione del Consiglio degli Stati per questo periodo — i voti nominali esistono solo dal 2022.',
  'parties.filteredBy': 'Filtrato per:',
  'parties.filtered': 'Filtrato:',
  'parties.nonAlignedFootnote': '{count} non iscritti non visualizzati — i membri ricoprono cariche esecutive (Consiglio federale) non assegnate a una camera parlamentare.',
  'parties.pctView': 'vista in %',
  'parties.sort': 'Ordina:',
  'parties.sortLeftRight': 'Sinistra → Destra',
  'parties.sortAlphabetical': 'Alfabetico',
  'parties.self': 'Sé stesso',
  'parties.seatsProportionTitle': 'Quota di tutti i seggi parlamentari',
  'parties.nrShort': 'CN',
  'parties.srShort': 'CS',
  'parties.notAffiliatedTitle': 'Membri non affiliati ad alcun partito registrato',
  'sessionDetail.councilVbv': 'VBV',
  'sessionDetail.councilVbvFull': 'Camere riunite',
  'sessionDetail.noSrVotes': 'Nessuna votazione per appello nominale del Consiglio degli Stati registrata per questa sessione (disponibile dal 2022).',
  'sessionDetail.donutTooltip': 'Somma di tutti i singoli voti Sì / No / astensione espressi in tutte le votazioni per appello nominale di questa sessione — totale dei voti, non il numero delle votazioni.',
  'sessionDetail.kpiAcceptedTooltip': 'Quante votazioni decisive della sessione si sono concluse con l’accettazione del progetto (e la loro quota). Le votazioni procedurali e di spareggio sono escluse; le votazioni in cui un «Sì» respinge una proposta sono conteggiate in base al risultato effettivo.',
  'sessionDetail.kpiRejectedTooltip': 'Quante votazioni decisive si sono concluse con il rifiuto del progetto (e la loro quota). Stessa base del dato sulle accettazioni — escluse le votazioni procedurali e di spareggio.',
  'sessionDetail.kpiParticipationTooltip': 'Numero medio di membri del consiglio che esprimono Sì, No o astensione per votazione — cioè i presenti. Assenze e giustificazioni non sono conteggiate.',
  'sessionDetail.calendarCountHint': 'Il numero accanto a ciascun consiglio (es. NR · 11) indica quanti oggetti sono stati trattati quel giorno.',
  'sessionDetail.noSession': 'Nessuna seduta',
  'sessionDetail.passRate': 'Tasso di accettazione',
  'sessionDetail.searchAgenda': 'Cerca tra {n} punti all\'ordine del giorno…',
  'sessionDetail.avgParticipation': 'Partecipazione media',
  'sessionDetail.councillorsPerVote': 'consiglieri / votazione',
  'sessionDetail.votesPerDay': 'Votazioni al giorno',
  'sessionDetail.mostContested': 'I più contesi',
  'sessionDetail.margin': 'scarto',
  'sessionDetail.colAffair': 'Oggetto',
  'sessionDetail.colTitle': 'Titolo',
  'sessionDetail.colResult': 'Risultato',
  'sessionDetail.viewVoteBreakdown': 'Visualizza dettaglio della votazione',
  'sessionDetail.absent': 'assente',
  'sessionDetail.votes': 'votazioni',
  'sessionDetail.totalAgendaItems': 'Totale punti all\'ordine del giorno',
  'common.weekday.mon': 'lun',
  'common.weekday.tue': 'mar',
  'common.weekday.wed': 'mer',
  'common.weekday.thu': 'gio',
  'common.weekday.fri': 'ven',
  'common.weekday.sat': 'sab',
  // localization pass 2: votes / members / bills / sessions / debates
  'votes.stichfrage': 'Domanda risolutiva',
  'votes.yesShort': 'Sì',
  'votes.noShort': 'No',
  'votes.factionSplit': 'Gruppo diviso',
  'votes.noData': 'nessun dato',
  'votes.voteNumber': 'Votazione n. ',
  'voteDetail.sortYesPct': 'Sì %',
  'voteDetail.sortNoPct': 'No %',
  'voteDetail.sortAbstain': 'A',
  'voteDetail.sortTotal': '#',
  'voteDetail.sortName': 'A–Z',
  'voteDetail.sortLabel': 'Ordina',
  'voteDetail.filterLabel': 'Filtra',
  'voteDetail.sortYesPctTip': 'Ordina per quota di voti Sì di ciascun gruppo (dal più alto)',
  'voteDetail.sortNoPctTip': 'Ordina per quota di voti No di ciascun gruppo (dal più alto)',
  'voteDetail.sortAbstainTip': 'Ordina per astensioni — presenti che non hanno votato né Sì né No',
  'voteDetail.sortTotalTip': 'Ordina per numero totale di membri di ciascun gruppo',
  'voteDetail.sortNameTip': 'Ordina alfabeticamente per nome',
  'voteDetail.filterAllTip': 'Mostra tutti i gruppi',
  'voteDetail.filterYesTip': 'Solo gruppi la cui maggioranza ha votato Sì',
  'voteDetail.filterNoTip': 'Solo gruppi la cui maggioranza ha votato No',
  'voteDetail.filterSplitTip': 'Solo gruppi in parità — stesso numero di Sì e No',
  'voteDetail.csvFirstName': 'Nome',
  'voteDetail.csvLastName': 'Cognome',
  'voteDetail.csvCanton': 'Cantone',
  'voteDetail.csvFaction': 'Gruppo',
  'voteDetail.csvDecision': 'Decisione',
  'voteDetail.csvDecisionCode': 'Codice decisione',
  'voteDetail.abstainShort': 'A',
  'voteDetail.absentShort': 'ass.',
  'voteAnalytics.cohesionSuffix': 'coesione',
  'faction.notFound': 'Gruppo non trovato.',
  'faction.partyComposition': 'Composizione dei partiti',
  'faction.memberSearchPlaceholder': 'Filtra per nome, cantone, partito…',
  'faction.canton': 'Cantone',
  'faction.subjectCol': 'Oggetto',
  'faction.organizationCol': 'Organizzazione',
  'faction.compensationCol': 'Retribuzione',
  'faction.interestsClickHint': 'Fai clic su una barra o un\'etichetta per filtrare le organizzazioni sottostanti.',
  'faction.typeCol': 'Tipo',
  'faction.totalSuffix': 'in totale',
  'members.csv.name': 'Nome',
  'members.csv.party': 'Partito',
  'members.csv.faction': 'Gruppo',
  'members.csv.canton': 'Cantone',
  'members.csv.council': 'Consiglio',
  'members.csv.active': 'Attivo',
  'members.appliedByChatbot': 'Applicato dal chatbot',
  'bills.csv.number': 'Numero',
  'bills.csv.title': 'Titolo',
  'bills.csv.type': 'Tipo',
  'bills.csv.status': 'Stato',
  'bills.csv.submissionDate': 'Data di presentazione',
  'bills.scoreDots.impactDescription': 'Quanto ampiamente questo oggetto incide sulla società, sull\'economia o sulle politiche pubbliche.',
  'bills.scoreDots.sensitivityDescription': 'Quanto questo oggetto rischia di essere politicamente controverso o divisivo.',
  'common.other': 'Altro',
  'memberDetail.speechCount': '{count} interventi',
  'memberCompare.remove': 'Rimuovi',
  'sessions.csv.session': 'Sessione',
  'sessions.csv.abbreviation': 'Sigla',
  'sessions.csv.type': 'Tipo',
  'sessions.csv.startDate': 'Data d\'inizio',
  'sessions.csv.endDate': 'Data di fine',
  'sessions.csv.legislativePeriod': 'Legislatura',
  'sessions.csv.votes': 'Votazioni',
  'sessions.csv.passRate': 'Tasso di approvazione (%)',
  'sessions.passRateComparison': 'Confronto del tasso di approvazione',
  'sessions.comparisonTitle': 'Confronto della sessione',
  'sessions.vsLastSession': 'rispetto alla sessione precedente',
  'sessions.vsSameSeasonLastYear': 'rispetto alla stessa sessione dell\'anno scorso',
  'sessions.passRateSuffix': '% approvati',
  'debates.csv.date': 'Data',
  'debates.csv.speaker': 'Oratore',
  'debates.csv.faction': 'Gruppo',
  'debates.csv.canton': 'Cantone',
  'debates.csv.council': 'Consiglio',
  'debates.csv.businessNumber': 'Numero dell\'oggetto',
  'debates.csv.businessTitle': 'Titolo dell\'oggetto',
  'debateDetail.missingSpeechId': 'ID dell\'intervento mancante. Accedi a questa pagina da una scheda di dibattito.',
  'debateDetail.role.proponent': 'Sostenitore',
  'debateDetail.role.critic': 'Critico',
  'debateDetail.role.expert': 'Esperto',
  'debateDetail.role.mediator': 'Mediatore',
  'debateDetail.role.stateRep': 'Rappr. esecutivo',
  'debateDetail.role.proponentDesc': 'Si esprime a favore del progetto in discussione — lo difende o ne promuove l’adozione.',
  'debateDetail.role.criticDesc': 'Si esprime criticamente contro il progetto — solleva obiezioni o opposizione. Descrive il tono retorico dell’intervento, non necessariamente il voto del membro.',
  'debateDetail.role.expertDesc': 'Si esprime come esperto della materia — spiega o chiarisce senza schierarsi.',
  'debateDetail.role.mediatorDesc': 'Cerca il compromesso o avvicina le posizioni contrapposte del dibattito.',
  'debateDetail.role.stateRepDesc': 'Si esprime a nome del governo / Consiglio federale (es. un consigliere federale), non come membro di un gruppo.',
  'debateDetail.role.rapporteur': 'Relatore',
  'debateDetail.role.rapporteurDesc': 'Portavoce ufficiale della commissione — presenta la posizione formale della commissione in aula, non una posizione personale.',
  'debateDetail.role.procedural': 'Procedura',
  'debateDetail.role.proceduralDesc': 'Interviene sulla procedura (questioni di ordine, ordine del giorno, modalità di voto) anziché sul merito.',
  'debateDetail.role.aiNote': 'Classificato dall’IA dal testo dell’intervento. Può differire dal voto effettivo del membro.',
  'debateDetail.sentiment.positive': 'Positivo',
  'debateDetail.sentiment.neutral': 'Neutro',
  'debateDetail.sentiment.negative': 'Negativo',
  'debateDetail.sentiment.positiveDesc': 'Il tono emotivo generale dell’intervento è positivo — di approvazione, ottimista o di sostegno nella formulazione.',
  'debateDetail.sentiment.neutralDesc': 'Il tono emotivo generale dell’intervento è neutro — fattuale o equilibrato, senza una forte carica positiva o negativa.',
  'debateDetail.sentiment.negativeDesc': 'Il tono emotivo generale dell’intervento è negativo — critico, di disapprovazione o pessimista nella formulazione. Riflette il tono, non necessariamente la posizione del membro.',
  'debateDetail.emotionality.tooltip': 'Quanto è emotivamente carico il linguaggio dell’intervento, su una scala da 0 a 10. Punteggi più alti indicano una formulazione più incisiva e appassionata; punteggi più bassi un tono misurato e fattuale.',
  'debateDetail.alignment.forDesc': 'L’intervento sostiene il progetto in discussione — si esprime a favore della sua adozione.',
  'debateDetail.alignment.againstDesc': 'L’intervento si oppone al progetto in discussione — si esprime contro la sua adozione.',
  'debateDetail.alignment.neutralDesc': 'L’intervento non prende una posizione chiara a favore o contro il progetto.',
  'debateDetail.alignment.conditionalDesc': 'L’intervento sostiene il progetto solo a determinate condizioni o con modifiche.',
  'committee.memberHeading': 'Membro',
  // localization pass 3: notifications / layout / cards / misc components
  'notif.unread': 'non letto',
  'notif.ago.seconds': '{n} s fa',
  'notif.ago.minutes': '{n} min fa',
  'notif.ago.hours': '{n} h fa',
  'notif.ago.days': '{n} g fa',
  'doc.permalink': 'Link permanente',
  'doc.breadcrumb': 'Percorso di navigazione',
  'doc.copy': 'Copia',
  'doc.copyCode': 'Copia il codice',
  'layout.expandSidebar': 'Espandi la barra laterale',
  'layout.collapseSidebar': 'Riduci la barra laterale',
  'topbar.signIn': 'Accedi',
  'tags.removeTag': 'Rimuovi etichetta',
  'tags.defaultColor': 'predefinito',
  'card.untitledAffair': '(oggetto senza titolo)',
  'card.councillor': 'Consigliere',
  'card.unknownCouncillor': 'Sconosciuto',
  'statusBadge.unknown': 'Sconosciuto',
  'filterPreset.saveFailed': 'Salvataggio non riuscito',
  'devInspector.toolCall': '{count} chiamata di strumento',
  'devInspector.toolCalls': '{count} chiamate di strumenti',
  'devInspector.iter': '{count} iter.',
  'devInspector.iterationLine': 'Iter. {iteration} · modello {modelMs}ms · strumenti {toolMs}ms',
  'devInspector.argsCount': '{count} arg.',
  'devInspector.args': 'arg.',
  'devInspector.resultPreview': 'anteprima del risultato',
  'chat.thinking': 'Sto pensando',
};

export default it;
